// Theme image_loading_style expects `.lazyloaded` from lazysizes. Eager native imgs (no lazyload class) never get it.
// FAQ banners now use `image-element` + lazysizes like other sections; this remains for any leftover eager markup.
function syncImageLoadingStyleClasses(root) {
  if (!root || !root.querySelectorAll) return;
  root
    .querySelectorAll(
      'img.blur-up:not(.lazyloaded), img.fade-in:not(.lazyloaded), img.transition--blur-up:not(.lazyloaded), img.transition--fade-in:not(.lazyloaded)'
    )
    .forEach(function (img) {
    function mark() {
      img.classList.add('lazyloaded');
    }
    if (img.complete) {
      mark();
    } else {
      img.addEventListener('load', mark, { once: true });
      img.addEventListener('error', mark, { once: true });
    }
  });
}

if (document.readyState !== 'loading') {
  syncImageLoadingStyleClasses(document);
}

document.addEventListener('DOMContentLoaded', function () {
  syncImageLoadingStyleClasses(document);

  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  let resizeTimeout;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
      lazysizesBackgroundImages.forEach(image => {
        let bg = image.getAttribute('data-bg');
        const mobileBg = image.getAttribute('data-mobile-bg');
        if (bg) {
          if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
            bg = mobileBg;
          }
          image.style.backgroundImage = `url(${bg})`;
        }
      });
    }, 66);
  }, false);
});

if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }

if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function (callback, cart) {
    if (!cart) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart request failed: ' + res.status);
          return res.json();
        })
        .then(function (cartJson) {
          var xhrLike = { responseText: JSON.stringify(cartJson) };
          if ((typeof callback) === 'function') {
            callback(cartJson, 'success', xhrLike);
          } else if (typeof Shopify.onCartUpdate === 'function') {
            Shopify.onCartUpdate(cartJson);
          }
          return cartJson;
        })
        .catch(function (err) {
          console.error('[Shopify.getCart]', err);
        });
    } else {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

function parseShopifyCartAddError(xhr) {
  var raw = xhr && xhr.responseText;
  if (!raw) {
    return '';
  }
  try {
    var parsed = JSON.parse(raw);
    if (parsed && typeof parsed.description === 'string') {
      return parsed.description;
    }
    if (parsed && Array.isArray(parsed.description)) {
      return parsed.description.join(' ');
    }
    if (parsed && typeof parsed.message === 'string') {
      return parsed.message;
    }
  } catch (err) {

  }
  return raw;
}


function floatToString(t, e) { var o = t.toFixed(e).toString(); return o.match(/^\.\d+/) ? "0" + o : o } if ("undefined" == typeof Shopify) var Shopify = {}; Shopify.each = function (t, e) { for (var o = 0; o < t.length; o++)e(t[o], o) }, Shopify.map = function (t, e) { for (var o = [], i = 0; i < t.length; i++)o.push(e(t[i], i)); return o }, Shopify.arrayIncludes = function (t, e) { for (var o = 0; o < t.length; o++)if (t[o] == e) return !0; return !1 }, Shopify.uniq = function (t) { for (var e = [], o = 0; o < t.length; o++)Shopify.arrayIncludes(e, t[o]) || e.push(t[o]); return e }, Shopify.isDefined = function (t) { return "undefined" == typeof t ? !1 : !0 }, Shopify.getClass = function (t) { return Object.prototype.toString.call(t).slice(8, -1) }, Shopify.extend = function (t, e) { function o() { } o.prototype = e.prototype, t.prototype = new o, t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype }, Shopify.locationSearch = function () { return window.location.search }, Shopify.locationHash = function () { return window.location.hash }, Shopify.replaceState = function (t) { window.history.replaceState({}, document.title, t) }, Shopify.urlParam = function (t) { var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch()); return e && decodeURIComponent(e[1].replace(/\+/g, " ")) }, Shopify.newState = function (t, e) { var o; return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash() }, Shopify.setParam = function (t, e) { Shopify.replaceState(Shopify.newState(t, e)) }, Shopify.Product = function (t) { Shopify.isDefined(t) && this.update(t) }, Shopify.Product.prototype.update = function (t) { for (property in t) this[property] = t[property] }, Shopify.Product.prototype.optionNames = function () { return "Array" == Shopify.getClass(this.options) ? this.options : [] }, Shopify.Product.prototype.optionValues = function (t) { if (!Shopify.isDefined(this.variants)) return null; var e = Shopify.map(this.variants, function (e) { var o = "option" + (t + 1); return void 0 == e[o] ? null : e[o] }); return null == e[0] ? null : Shopify.uniq(e) }, Shopify.Product.prototype.getVariant = function (t) { var e = null; return t.length != this.options.length ? e : (Shopify.each(this.variants, function (o) { for (var i = !0, r = 0; r < t.length; r++) { var n = "option" + (r + 1); o[n] != t[r] && (i = !1) } return 1 == i ? void (e = o) : void 0 }), e) }, Shopify.Product.prototype.getVariantById = function (t) { for (var e = 0; e < this.variants.length; e++) { var o = this.variants[e]; if (t == o.id) return o } return null }, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function (t, e) { function o(t, e) { return "undefined" == typeof t ? e : t } function i(t, e, i, r) { if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0; t = (t / 100).toFixed(e); var n = t.split("."), a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i), s = n[1] ? r + n[1] : ""; return a + s } "string" == typeof t && (t = t.replace(".", "")); var r = "", n = /\{\{\s*(\w+)\s*\}\}/, a = e || this.money_format; switch (a.match(n)[1]) { case "amount": r = i(t, 2); break; case "amount_no_decimals": r = i(t, 0); break; case "amount_with_comma_separator": r = i(t, 2, ".", ","); break; case "amount_no_decimals_with_comma_separator": r = i(t, 0, ".", ",") }return a.replace(n, r) }, Shopify.OptionSelectors = function (t, e) { return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () { }, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0 }, Shopify.OptionSelectors.prototype.initDropdown = function () { var t = { initialLoad: !0 }, e = this.selectVariantFromDropdown(t); if (!e) { var o = this; setTimeout(function () { o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t) }) } }, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) { this.selectors[0].element.onchange(t) }, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) { var e = this.selectVariantFromParams(t); e || this.selectVariantFromDropdown(t) }, Shopify.OptionSelectors.prototype.replaceSelector = function (t) { var e = document.getElementById(t), o = e.parentNode; Shopify.each(this.buildSelectors(), function (t) { o.insertBefore(t, e) }), e.style.display = "none", this.variantIdField = e }, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) { var e = document.getElementById(this.domIdPrefix).querySelector("[selected]"); if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1; var o = e.value; return this.selectVariant(o, t) }, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) { var e = Shopify.urlParam("variant"); return this.selectVariant(e, t) }, Shopify.OptionSelectors.prototype.selectVariant = function (t, e) { var o = this.product.getVariantById(t); if (null == o) return !1; for (var i = 0; i < this.selectors.length; i++) { var r = this.selectors[i].element, n = r.getAttribute("data-option"), a = o[n]; null != a && this.optionExistInSelect(r, a) && (r.value = a) } return this.selectors[0].element.onchange(e), !0 }, Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) { for (var o = 0; o < t.options.length; o++)if (t.options[o].value == e) return !0 }, Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) { Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector"; var o = document.getElementById(t); Shopify.each(this.buildSelectors(), function (t) { o.appendChild(t) }) }, Shopify.OptionSelectors.prototype.buildSelectors = function () { for (var t = 0; t < this.product.optionNames().length; t++) { var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t)); e.element.disabled = !1, this.selectors.push(e) } var o = this.selectorDivClass, i = this.product.optionNames(), r = Shopify.map(this.selectors, function (t) { var e = document.createElement("div"); if (e.setAttribute("class", o), i.length > 1) { var r = document.createElement("label"); r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r) } return e.appendChild(t.element), e }); return r }, Shopify.OptionSelectors.prototype.selectedValues = function () { for (var t = [], e = 0; e < this.selectors.length; e++) { var o = this.selectors[e].element.value; t.push(o) } return t }, Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) { var o = this.selectedValues(), i = this.product.getVariant(o); i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e) }, Shopify.OptionSelectorsFromDOM = function (t, e) { var o = e.optionNames || [], i = e.priceFieldExists || !0, r = e.delimiter || "/", n = this.createProductFromSelector(t, o, i, r); e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e) }, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) { if (!Shopify.isDefined(o)) var o = !0; if (!Shopify.isDefined(i)) var i = "/"; var r = document.getElementById(t), n = r.childNodes, a = (r.parentNode, e.length), s = []; Shopify.each(n, function (t, r) { if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) { var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*")); 0 == e.length && (a = n.length - (o ? 1 : 0)); var p = n.slice(0, a), l = o ? n[a] : "", c = (t.getAttribute("value"), { available: t.disabled ? !1 : !0, id: parseFloat(t.value), price: l, option1: p[0], option2: p[1], option3: p[2] }); s.push(c) } }); var p = { variants: s }; if (0 == e.length) { p.options = []; for (var l = 0; a > l; l++)p.options[l] = "option " + (l + 1) } else p.options = e; return p }, Shopify.SingleOptionSelector = function (t, e, o, i) { this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select"); for (var r = 0; r < i.length; r++) { var n = document.createElement("option"); n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n) } return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function (o, i) { i = i || {}, t.updateSelectors(e, i) }, !0 }, Shopify.Image = { preload: function (t, e) { for (var o = 0; o < t.length; o++) { var i = t[o]; this.loadImage(this.getSizedImageUrl(i, e)) } }, loadImage: function (t) { (new Image).src = t }, switchImage: function (t, e, o) { if (t && e) { var i = this.imageSize(e.src), r = this.getSizedImageUrl(t.src, i); o ? o(r, t, e) : e.src = r } }, imageSize: function (t) { var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./); return null != e ? e[1] : null }, getSizedImageUrl: function (t, e) { if (null == e) return t; if ("master" == e) return this.removeProtocol(t); var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i); if (null != o) { var i = t.split(o[0]), r = o[0]; return this.removeProtocol(i[0] + "_" + e + r) } return null }, removeProtocol: function (t) { return t.replace(/http(s)?:/, "") } }, Shopify.OptionSelectors.HistoryState = function (t) { this.browserSupports() && this.register(t) }, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) { window.addEventListener("popstate", function (e) { t.selectVariantFromParamsOrDropdown({ popStateCall: !0 }) }) }, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) { this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id)) }, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () { return window.history && window.history.replaceState };



(function () {
  function pathSegments(urlStr) {
    try {
      var u = new URL(urlStr, window.location.href);
      return u.pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);
    } catch (err) {
      return [];
    }
  }

  function parseQuery(keyWithQuestion, urlStr) {
    var name = keyWithQuestion.slice(1);
    try {
      var u = new URL(urlStr, window.location.href);
      var v = u.searchParams.get(name);
      return v === null ? '' : v;
    } catch (e) {
      return '';
    }
  }

  function url(key, urlStr) {
    urlStr = urlStr || window.location.href;
    if (key === 'tld?') return {};
    if (!key) return urlStr;
    var k = String(key);
    if (k.charAt(0) === '?') return parseQuery(k, urlStr);
    if (/^-?\d+$/.test(k)) {
      var parts = pathSegments(urlStr);
      var n = parseInt(k, 10);
      var idx = n < 0 ? parts.length + n : n - 1;
      return parts[idx] !== undefined ? parts[idx] : '';
    }
    return '';
  }

  window.url = url;
})();

var themeRemodal = (function () {
  var ANIM_MS = 320;
  var STATE_CLASSES = ['remodal-is-opening', 'remodal-is-opened', 'remodal-is-closing', 'remodal-is-closed'];
  var instances = {};
  var overlay = null;
  var activeInstance = null;
  var savedBodyPaddingRight = '';
  var hashScrollY = 0;
  var globalsBound = false;

  function defaults() {
    return {
      hashTracking: true,
      closeOnConfirm: true,
      closeOnCancel: true,
      closeOnEscape: true,
      closeOnOutsideClick: true
    };
  }

  function parseRemodalOptions(str) {
    var out = {};
    if (!str || typeof str !== 'string') return out;
    var normalized = str.replace(/\s*:\s*/g, ':').replace(/\s*,\s*/g, ',');
    var parts = normalized.split(',');
    for (var i = 0; i < parts.length; i++) {
      var seg = parts[i].trim();
      if (!seg) continue;
      var colon = seg.indexOf(':');
      if (colon < 1) continue;
      var key = seg.slice(0, colon).trim();
      var val = seg.slice(colon + 1).trim();
      if (val === 'true') val = true;
      else if (val === 'false') val = false;
      else if (!isNaN(Number(val)) && val !== '') val = Number(val);
      out[key] = val;
    }
    return out;
  }

  function mergeOpts(attrStr) {
    var parsed = parseRemodalOptions(attrStr || '');
    var base = defaults();
    Object.keys(parsed).forEach(function (k) {
      if (parsed[k] !== undefined) base[k] = parsed[k];
    });
    return base;
  }

  function scrollbarWidth() {
    if (document.body.scrollHeight <= window.innerHeight) return 0;
    var outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    document.body.appendChild(outer);
    var w = outer.offsetWidth;
    outer.style.overflow = 'scroll';
    var inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);
    var w2 = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return w - w2;
  }

  function stripStates(el) {
    if (!el) return;
    STATE_CLASSES.forEach(function (c) {
      el.classList.remove(c);
    });
  }

  function ensureOverlay() {
    if (overlay) return;
    overlay = document.querySelector('.remodal-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'remodal-overlay remodal-is-closed';
      document.body.appendChild(overlay);
    } else {
      stripStates(overlay);
      overlay.classList.add('remodal-is-closed');
    }
  }

  function lockScroll() {
    var html = document.documentElement;
    if (html.classList.contains('remodal-is-locked')) return;
    var sb = scrollbarWidth();
    var pr = parseInt(window.getComputedStyle(document.body).paddingRight, 10) || 0;
    savedBodyPaddingRight = document.body.style.paddingRight;
    document.body.style.paddingRight = pr + sb + 'px';
    html.classList.add('remodal-is-locked');
  }

  function unlockScroll() {
    var html = document.documentElement;
    if (!html.classList.contains('remodal-is-locked')) return;
    document.body.style.paddingRight = savedBodyPaddingRight;
    html.classList.remove('remodal-is-locked');
  }

  function dispatch(modal, type, detail) {
    modal.dispatchEvent(
      new CustomEvent(type, {
        bubbles: true,
        cancelable: true,
        detail: detail || {}
      })
    );
  }

  function closeInstance(inst, reason, done) {
    if (!inst || activeInstance !== inst) {
      if (typeof done === 'function') done();
      return;
    }

    stripStates(overlay);
    overlay.classList.add('remodal-is-closing');
    overlay.style.display = 'block';

    stripStates(inst.wrapper);
    inst.wrapper.classList.add('remodal-is-closing');

    stripStates(inst.modal);
    inst.modal.classList.add('remodal-is-closing');

    if (inst.options.hashTracking && location.hash === '#' + inst.id) {
      history.replaceState(null, document.title, location.pathname + location.search);
      window.scrollTo(0, hashScrollY);
    }

    window.setTimeout(function () {
      overlay.style.display = 'none';
      stripStates(overlay);
      overlay.classList.add('remodal-is-closed');

      inst.wrapper.style.display = 'none';
      stripStates(inst.wrapper);
      inst.wrapper.classList.add('remodal-is-closed');

      stripStates(inst.modal);
      inst.modal.classList.add('remodal-is-closed');

      unlockScroll();
      activeInstance = null;

      dispatch(inst.modal, 'closed', { reason: reason });

      if (typeof done === 'function') done();
    }, ANIM_MS);
  }

  function finishOpen(inst) {
    stripStates(overlay);
    overlay.classList.add('remodal-is-opened');

    stripStates(inst.wrapper);
    inst.wrapper.classList.add('remodal-is-opened');

    stripStates(inst.modal);
    inst.modal.classList.add('remodal-is-opened');

    try {
      inst.modal.focus();
    } catch (e) { }

    dispatch(inst.modal, 'opened', {});
  }

  function openInstance(inst) {
    if (!inst) return;
    if (activeInstance && activeInstance !== inst) {
      closeInstance(activeInstance, null, function () {
        openInstance(inst);
      });
      return;
    }

    activeInstance = inst;
    lockScroll();

    overlay.style.display = 'block';
    stripStates(overlay);
    overlay.classList.add('remodal-is-opening');

    inst.wrapper.style.display = 'block';
    stripStates(inst.wrapper);
    inst.wrapper.classList.add('remodal-is-opening');
    inst.wrapper.scrollTop = 0;

    stripStates(inst.modal);
    inst.modal.classList.add('remodal-is-opening');

    if (inst.options.hashTracking) {
      hashScrollY = window.pageYOffset;
      location.hash = inst.id;
    }

    window.setTimeout(function () {
      finishOpen(inst);
    }, ANIM_MS);
  }

  function setupModal(modal) {
    var id = modal.getAttribute('data-remodal-id');
    if (!id || instances[id]) return;

    var opts = mergeOpts(modal.getAttribute('data-remodal-options'));

    var wrapper = document.createElement('div');
    wrapper.className = 'remodal-wrapper remodal-is-closed';

    var parent = modal.parentNode;
    if (!parent) return;
    parent.insertBefore(wrapper, modal);
    wrapper.appendChild(modal);
    document.body.appendChild(wrapper);

    if (!modal.classList.contains('remodal')) modal.classList.add('remodal');
    modal.classList.add('remodal-is-initialized', 'remodal-is-closed');
    modal.setAttribute('tabindex', '-1');

    instances[id] = { id: id, modal: modal, wrapper: wrapper, options: opts };
  }

  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;

    document.body.addEventListener('click', function (ev) {
      var trig = ev.target.closest('[data-remodal-target]');
      if (trig) {
        ev.preventDefault();
        var tid = trig.getAttribute('data-remodal-target');
        if (tid && instances[tid]) openInstance(instances[tid]);
        return;
      }

      var act = ev.target.closest('[data-remodal-action]');
      if (!act || !activeInstance) return;
      if (!activeInstance.modal.contains(act)) return;

      var action = act.getAttribute('data-remodal-action');
      if (action === 'close') {
        ev.preventDefault();
        closeInstance(activeInstance);
      } else if (action === 'confirm') {
        ev.preventDefault();
        dispatch(activeInstance.modal, 'confirmation', {});
        if (activeInstance.options.closeOnConfirm) closeInstance(activeInstance, 'confirmation');
      } else if (action === 'cancel') {
        ev.preventDefault();
        dispatch(activeInstance.modal, 'cancellation', {});
        if (activeInstance.options.closeOnCancel) closeInstance(activeInstance, 'cancellation');
      }
    });

    document.body.addEventListener(
      'click',
      function (ev) {
        if (!activeInstance || !activeInstance.options.closeOnOutsideClick) return;
        if (ev.target === activeInstance.wrapper) {
          closeInstance(activeInstance);
        }
      },
      true
    );

    document.addEventListener('keydown', function (ev) {
      if (ev.keyCode !== 27 || !activeInstance) return;
      if (!activeInstance.options.closeOnEscape) return;
      closeInstance(activeInstance);
    });
  }

  function scan() {
    ensureOverlay();
    themeDom.qsa('[data-remodal-id]').forEach(setupModal);
    bindGlobals();
  }

  return {
    init: scan,
    openSelector: function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;
      var id = el.getAttribute('data-remodal-id');
      if (id && instances[id]) openInstance(instances[id]);
    },
    closeSelector: function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;
      var id = el.getAttribute('data-remodal-id');
      if (id && instances[id] && activeInstance === instances[id]) closeInstance(instances[id]);
    }
  };
})();

// jQuery .slideToggle() default duration; shared by collection sidebar (vanilla) and FAQ panels.
var ACCORDION_SLIDE_MS = 400;

var themeDom = {
  el: function (t) {
    if (!t) return null;
    if (t.nodeType === 1 || t.nodeType === 9 || t.nodeType === 11) return t;
    if (typeof t.length === 'number' && t.length > 0 && t[0] && (t[0].nodeType === 1 || t[0].nodeType === 9 || t[0].nodeType === 11)) {
      return t[0];
    }
    return t;
  },
  qs: function (sel, root) {
    var r = themeDom.el(root) || document;
    return r.querySelector ? r.querySelector(sel) : null;
  },
  qsa: function (sel, root) {
    var r = themeDom.el(root) || document;
    return Array.prototype.slice.call(r.querySelectorAll(sel));
  },
  windowWidth: function () {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  },
  scrollTop: function () {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  },
  isVisible: function (el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  },
  fetchHtml: function (url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    });
  },
  parseHtmlDoc: function (html) {
    return new DOMParser().parseFromString(html, 'text/html');
  },
  flickityCreate: function (el, opts) {
    if (!window.Flickity || !el) return null;
    return new window.Flickity(el, opts);
  },
  flickityDestroy: function (el) {
    var node = themeDom.el(el);
    var flkty = window.Flickity && node ? window.Flickity.data(node) : null;
    if (flkty) flkty.destroy();
  },
  flickityData: function (el) {
    var node = themeDom.el(el);
    return window.Flickity && node ? window.Flickity.data(node) : null;
  },
  flickityAppend: function (el, htmlOrNode) {
    var flkty = themeDom.flickityData(el);
    if (!flkty) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = typeof htmlOrNode === 'string' ? htmlOrNode : '';
    var cell = typeof htmlOrNode === 'string' ? wrap.firstElementChild : htmlOrNode;
    if (cell) flkty.append(cell);
  },
  flickityRemove: function (galleryEl, cellsSelector) {
    var flkty = themeDom.flickityData(galleryEl);
    if (!flkty) return;
    themeDom.qsa(cellsSelector, galleryEl).forEach(function (c) {
      flkty.remove(c);
    });
  },
  show: function (el, display) {
    el = themeDom.el(el);
    if (el) el.style.display = display != null ? display : '';
  },
  hide: function (el) {
    el = themeDom.el(el);
    if (el) el.style.display = 'none';
  },
  toggleDisplay: function (el, show) {
    el = themeDom.el(el);
    if (!el) return;
    el.style.display = show ? '' : 'none';
  },
  css: function (el, props) {
    el = themeDom.el(el);
    if (!el || !props) return;
    Object.keys(props).forEach(function (k) {
      el.style[k.replace(/-([a-z])/g, function (_, a) { return a.toUpperCase(); })] = props[k];
    });
  },
  text: function (el, v) {
    el = themeDom.el(el);
    if (!el) return '';
    if (v !== undefined) el.textContent = v;
    return el.textContent;
  },
  html: function (el, v) {
    el = themeDom.el(el);
    if (!el) return '';
    if (v !== undefined) el.innerHTML = v;
    return el.innerHTML;
  },
  attr: function (el, name, val) {
    el = themeDom.el(el);
    if (!el) return null;
    if (val !== undefined) {
      if (val === null) el.removeAttribute(name);
      else el.setAttribute(name, val);
      return val;
    }
    return el.getAttribute(name);
  },
  dataAttr: function (el, key, val) {
    el = themeDom.el(el);
    if (!el) return;
    var k = key.replace(/([A-Z])/g, '-$1').toLowerCase();
    var attr = 'data-' + k;
    if (val !== undefined) {
      el.setAttribute(attr, typeof val === 'object' ? JSON.stringify(val) : val);
      return val;
    }
    var s = el.getAttribute(attr);
    if (s && (s[0] === '{' || s[0] === '[')) {
      try {
        return JSON.parse(s);
      } catch (e) { }
    }
    return s;
  },
  trigger: function (el, eventName, detail) {
    el = themeDom.el(el);
    if (!el) return;
    var ev = new CustomEvent(eventName, { bubbles: true, cancelable: true, detail: detail });
    el.dispatchEvent(ev);
  },
  serializeForm: function (form) {
    if (!form || form.nodeName !== 'FORM') return '';
    var pairs = [];
    Array.prototype.slice.call(form.elements).forEach(function (fld) {
      if (!fld.name || fld.disabled) return;
      var tag = fld.nodeName.toLowerCase();
      var typ = (fld.type || '').toLowerCase();
      if (tag === 'button' || typ === 'file' || typ === 'reset') return;
      if ((typ === 'checkbox' || typ === 'radio') && !fld.checked) return;
      pairs.push(encodeURIComponent(fld.name) + '=' + encodeURIComponent(fld.value));
    });
    return pairs.join('&');
  },
  param: function (obj) {
    if (!obj) return '';
    return Object.keys(obj)
      .map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k] == null ? '' : String(obj[k]));
      })
      .join('&');
  },
  urlSeg: function (key, urlStr) {
    if (typeof window.url === 'function') return window.url(key, urlStr || window.location.toString());
    return '';
  },
  ajax: function (opts) {
    var method = (opts.type || 'GET').toUpperCase();
    var url = opts.url;
    var headers = opts.headers || {};
    var done = function () { };
    var fail = function () { };
    if (opts.beforeSend) opts.beforeSend();
    if (opts.dataType === 'jsonp') {
      var cbName = 'jp_' + Date.now() + '_' + Math.floor(Math.random() * 9999);
      window[cbName] = function (data) {
        delete window[cbName];
        document.head.removeChild(script);
        if (opts.success) opts.success(data);
      };
      var script = document.createElement('script');
      script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + cbName;
      script.onerror = function () {
        delete window[cbName];
        if (opts.error) opts.error();
      };
      document.head.appendChild(script);
      return;
    }
    var body = null;
    if (opts.data != null) {
      if (typeof opts.data === 'string') {
        body = opts.data;
        if (method === 'GET') {
          url += (url.indexOf('?') >= 0 ? '&' : '?') + body;
          body = null;
        } else {
          headers['Content-Type'] = headers['Content-Type'] || 'application/x-www-form-urlencoded; charset=UTF-8';
        }
      } else if (method !== 'GET') {
        headers['Content-Type'] = headers['Content-Type'] || 'application/x-www-form-urlencoded; charset=UTF-8';
        body = themeDom.param(opts.data);
      } else {
        url += (url.indexOf('?') >= 0 ? '&' : '?') + themeDom.param(opts.data);
      }
    }
    fetch(url, {
      method: method,
      credentials: 'same-origin',
      headers: headers,
      body: body && method !== 'GET' ? body : undefined
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var xhrLike = {
            status: res.status,
            responseText: text || '',
            responseJSON: null
          };
          try {
            if (text && (text.charAt(0) === '{' || text.charAt(0) === '[')) {
              xhrLike.responseJSON = JSON.parse(text);
            }
          } catch (ignoreParse) {}
          if (!res.ok) {
            throw { xhr: xhrLike, res: res };
          }
          if (opts.dataType === 'json') {
            if (xhrLike.responseJSON !== null && xhrLike.responseJSON !== undefined) {
              return xhrLike.responseJSON;
            }
            try {
              return text ? JSON.parse(text) : {};
            } catch (e2) {
              return {};
            }
          }
          return text;
        });
      })
      .then(function (data) {
        if (opts.success) opts.success(data);
      })
      .catch(function (err) {
        var xhr = err && err.xhr ? err.xhr : { responseText: '', status: 0 };
        if (opts.error) opts.error(xhr, 'error', String(err));
      });
  },
  ajaxSyncJson: function (url) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    xhr.send(null);
    if (xhr.status >= 200 && xhr.status < 300) {
      try {
        return JSON.parse(xhr.responseText);
      } catch (e) {
        return null;
      }
    }
    return null;
  },
  fadeOut: function (el, speed, cb) {
    el = themeDom.el(el);
    if (!el) return;
    var ms = speed === 'slow' ? 600 : typeof speed === 'number' ? speed : 400;
    el.style.transition = 'opacity ' + ms + 'ms ease';
    el.style.opacity = '0';
    setTimeout(function () {
      el.style.display = 'none';
      if (cb) cb();
    }, ms);
  },
  fadeIn: function (el, speed, cb) {
    el = themeDom.el(el);
    if (!el) return;
    var ms = speed === 'slow' ? 600 : typeof speed === 'number' ? speed : 400;
    el.style.display = '';
    el.style.opacity = '0';
    el.style.transition = 'opacity ' + ms + 'ms ease';
    requestAnimationFrame(function () {
      el.style.opacity = '1';
    });
    setTimeout(function () {
      if (cb) cb();
    }, ms);
  },
  slideToggle: function (el, cb, durationMs) {
    el = themeDom.el(el);
    if (!el) return;
    // Default 250ms; pass durationMs for ACCORDION_SLIDE_MS (toggle_list + FAQ) or other custom timings.
    var slideMs =
      typeof durationMs === 'number' && durationMs > 0 ? Math.round(durationMs) : 250;
    // Closer to jQuery's default "swing" than CSS keyword `ease`; avoids end-of-tween hitch vs plain ease.
    var easeCss = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
    var open = window.getComputedStyle(el).display !== 'none';

    if (open) {
      el.style.overflow = 'hidden';
      var h = el.scrollHeight;
      el.style.maxHeight = h + 'px';
      void el.offsetHeight;
      var doneClose = false;
      function finishClose() {
        if (doneClose) return;
        doneClose = true;
        clearTimeout(closeFallback);
        el.removeEventListener('transitionend', onCloseEnd);
        el.style.display = 'none';
        el.style.maxHeight = '';
        el.style.transition = '';
        el.style.overflow = '';
        if (cb) cb();
      }
      function onCloseEnd(e) {
        if (e && (e.target !== el || e.propertyName !== 'max-height')) return;
        finishClose();
      }
      var closeFallback = setTimeout(function () {
        finishClose();
      }, slideMs + 120);
      el.addEventListener('transitionend', onCloseEnd);
      requestAnimationFrame(function () {
        el.style.transition = 'max-height ' + slideMs + 'ms ' + easeCss;
        el.style.maxHeight = '0';
      });
    } else {
      el.style.display = el.tagName === 'TR' ? 'table-row' : 'block';
      el.style.overflow = 'hidden';
      void el.offsetHeight;
      var target = el.scrollHeight;
      el.style.maxHeight = '0';
      void el.offsetHeight;
      var doneOpen = false;
      function finishOpen() {
        if (doneOpen) return;
        doneOpen = true;
        clearTimeout(openFallback);
        el.removeEventListener('transitionend', onOpenEnd);
        el.style.maxHeight = '';
        el.style.transition = '';
        el.style.overflow = '';
        if (cb) cb();
      }
      function onOpenEnd(e) {
        if (e && (e.target !== el || e.propertyName !== 'max-height')) return;
        finishOpen();
      }
      var openFallback = setTimeout(function () {
        finishOpen();
      }, slideMs + 120);
      el.addEventListener('transitionend', onOpenEnd);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.style.transition = 'max-height ' + slideMs + 'ms ' + easeCss;
          el.style.maxHeight = target + 'px';
        });
      });
    }
  },
  scrollAnimateY: function (top, duration) {
    duration = parseInt(duration, 10) || 500;
    var start = themeDom.scrollTop();
    var dist = top - start;
    var t0 = Date.now();
    function tick() {
      var t = Math.min(1, (Date.now() - t0) / duration);
      var ease = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      window.scrollTo(0, start + dist * ease);
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  },
  scrollToEl: function (targetSel, offset) {
    var el = themeDom.qs(targetSel);
    if (!el) return;
    var y = el.getBoundingClientRect().top + themeDom.scrollTop() + (offset || 0);
    themeDom.scrollAnimateY(y, 500);
  },
  remodalOpen: function (selector) {
    if (typeof themeRemodal !== 'undefined') themeRemodal.openSelector(selector);
  },
  remodalClose: function (selector) {
    if (typeof themeRemodal !== 'undefined') themeRemodal.closeSelector(selector);
  },

  jqZoomInit: function (zoomParentSel, enableTouch, magnify) {
    var parent = themeDom.qs(zoomParentSel);
    if (!parent) return;
    var activateZoom = themeDom.dataAttr(parent, 'zoom');
    if (activateZoom == null || activateZoom === false || activateZoom === 'false') return;
    magnify = magnify != null ? magnify : 1;

    themeDom.qsa(zoomParentSel + ' img').forEach(function (img) {
      var wrap = img.parentElement;
      if (wrap && wrap.classList.contains('theme-zoom-root') && wrap._themeZoomBound) return;

      if (!wrap || !wrap.classList.contains('theme-zoom-root')) {
        wrap = document.createElement('span');
        wrap.className = 'theme-zoom-root';
        wrap.style.display = 'inline-block';
        img.style.display = 'block';
        img.parentNode.insertBefore(wrap, img);
        wrap.appendChild(img);
      }

      wrap._themeZoomBound = true;
      wrap.style.position = 'relative';
      wrap.style.overflow = 'hidden';

      var zoomImg = document.createElement('img');
      zoomImg.className = 'zoomImg';
      zoomImg.setAttribute('role', 'presentation');
      zoomImg.alt = '';
      zoomImg.style.cssText =
        'opacity:0;pointer-events:none;position:absolute;top:0;left:0;border:none;max-width:none;max-height:none;transition:opacity 120ms ease';

      var url = img.getAttribute('data-src') || img.currentSrc || img.src;
      zoomImg.onload = function () {
        var nw = zoomImg.naturalWidth * magnify;
        var nh = zoomImg.naturalHeight * magnify;
        zoomImg.style.width = nw + 'px';
        zoomImg.style.height = nh + 'px';

        function move(ev) {
          var e = ev && ev.touches ? ev.touches[0] : ev;
          if (!e || e.clientX == null) return;
          var rect = wrap.getBoundingClientRect();
          var mx = e.clientX - rect.left;
          var my = e.clientY - rect.top;
          mx = Math.max(0, Math.min(mx, rect.width));
          my = Math.max(0, Math.min(my, rect.height));
          var maxL = wrap.offsetWidth - nw;
          var maxT = wrap.offsetHeight - nh;
          zoomImg.style.left = (mx / rect.width) * maxL + 'px';
          zoomImg.style.top = (my / rect.height) * maxT + 'px';
        }

        function show(ev) {
          move(ev);
          zoomImg.style.opacity = '1';
        }
        function hide() {
          zoomImg.style.opacity = '0';
        }

        wrap.addEventListener('mouseenter', show);
        wrap.addEventListener('mousemove', function (ev) {
          if (zoomImg.style.opacity !== '0') move(ev);
        });
        wrap.addEventListener('mouseleave', hide);

        if (enableTouch) {
          var touchOn = false;
          wrap.addEventListener(
            'touchstart',
            function (ev) {
              ev.preventDefault();
              if (!touchOn) {
                touchOn = true;
                show(ev.touches[0] || ev);
              } else {
                touchOn = false;
                hide();
              }
            },
            { passive: false }
          );
          wrap.addEventListener(
            'touchmove',
            function (ev) {
              if (touchOn) {
                ev.preventDefault();
                move(ev.touches[0] || ev);
              }
            },
            { passive: false }
          );
        }

        wrap.appendChild(zoomImg);
      };
      zoomImg.src = url;
    });
  },

  jqMediaWrapper: function (selectorOrEl, opts) {
    opts = opts || {};
    var intrinsic = opts.intrinsic !== false;
    var baseW = opts.baseWidth != null ? opts.baseWidth : 16;
    var baseH = opts.baseHeight != null ? opts.baseHeight : 9;
    var el = typeof selectorOrEl === 'string' ? themeDom.qs(selectorOrEl) : themeDom.el(selectorOrEl);
    if (!el || el.tagName !== 'IFRAME') return;
    if (el.parentElement && el.parentElement.classList.contains('mediaWrapper')) return;

    var pct;
    if (intrinsic && el.getAttribute('width') && el.getAttribute('height')) {
      var w = parseFloat(el.getAttribute('width'), 10);
      var h = parseFloat(el.getAttribute('height'), 10);
      pct = w > 0 && h > 0 ? (h / w) * 100 : (baseH / baseW) * 100;
    } else {
      pct = (baseH / baseW) * 100;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'mediaWrapper';
    wrapper.style.cssText = 'position:relative;width:100%;height:0;padding:' + pct + '% 0 0 0';
    el.style.cssText = 'position:absolute;width:100%;height:100%;top:0;left:0;border:0';
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },
  isOffRight: function (el) {
    el = themeDom.el(el);
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.right > window.innerWidth;
  },
  onRevealPct: function (element, pct, fn) {
    if (!element || typeof fn !== 'function') return;
    var margin = pct != null ? 100 - pct : 30;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            fn(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -' + margin + '% 0px', threshold: 0 }
    );
    io.observe(themeDom.el(element));
  },

  onReveal80: function (element, fn) {
    themeDom.onRevealPct(element, 80, fn);
  },
  delegate: function (root, eventName, selector, handler) {
    root = themeDom.el(root) || document;
    root.addEventListener(eventName, function (e) {
      var el = e.target;
      if (el && el.nodeType === 3) {
        el = el.parentElement;
      }
      var t = null;
      if (eventName === 'submit') {
        if (el && el.tagName === 'FORM' && typeof el.matches === 'function' && el.matches(selector)) {
          t = el;
        } else if (el && typeof el.closest === 'function') {
          t = el.closest(selector);
        }
      } else if (el && typeof el.closest === 'function') {
        t = el.closest(selector);
      }
      if (t && root.contains(t)) handler.call(t, e);
    });
  },
  htmlEncodeText: function (value) {
    if (!value) return '';
    var d = document.createElement('div');
    d.textContent = value;
    return d.innerHTML;
  },
  jqTriggerClick: function (sel) {
    var el = typeof sel === 'string' ? document.querySelector(sel) : themeDom.el(sel);
    if (el && typeof el.click === 'function') el.click();
  },

  flexsliderUnwrapLists: function () {
    themeDom.qsa('.slider, .flexslider').forEach(function (wrap) {
      var ul = wrap.querySelector(':scope > ul');
      if (!ul) return;
      while (ul.firstChild) wrap.insertBefore(ul.firstChild, ul);
      if (ul.parentNode) ul.parentNode.removeChild(ul);
    });
  },
  parents: function (el, selector) {
    var out = [];
    var p = el && el.parentElement;
    while (p) {
      if (p.matches(selector)) out.push(p);
      p = p.parentElement;
    }
    return out;
  },
  closestParent: function (el, selector) {
    var p = el && el.parentElement;
    while (p) {
      if (p.matches(selector)) return p;
      p = p.parentElement;
    }
    return null;
  },
  prevAllClick: function (el) {
    if (el && el.click) el.click();
  },
  empty: function (el) {
    el = themeDom.el(el);
    if (!el) return;
    el.innerHTML = '';
  },
  appendHtml: function (el, html) {
    el = themeDom.el(el);
    if (!el) return;
    el.insertAdjacentHTML('beforeend', html);
  },
  extend: function (a, b) {
    if (!a || !b) return a;
    Object.keys(b).forEach(function (k) {
      a[k] = b[k];
    });
    return a;
  }
};



var usePageDots = Shopify.theme_settings.page_dots_enabled;

var imageFunctions = {
  zoom: function (zoomParent, enableTouch, magnify) {
    themeDom.jqZoomInit(zoomParent, enableTouch, magnify);
  },
  linkGalleryAndCarousel: function (galleryEl, carouselEl) {
    var gallery = themeDom.el(galleryEl);
    var carousel = themeDom.el(carouselEl);
    if (!gallery || !carousel) return;

    var firstNav = carousel.querySelector('.gallery-cell:nth-child(1)');
    if (firstNav) firstNav.classList.add('is-nav-selected');

    carousel.addEventListener('click', function (e) {
      var cell = e.target.closest('.gallery-cell');
      if (!cell || !carousel.contains(cell)) return;
      var cells = carousel.querySelectorAll('.gallery-cell');
      var index = Array.prototype.indexOf.call(cells, cell);
      themeDom.qsa('.is-nav-selected', carousel).forEach(function (n) {
        n.classList.remove('is-nav-selected');
      });
      cell.classList.add('is-nav-selected');
      var gFlkty = themeDom.flickityData(gallery);
      if (gFlkty) gFlkty.select(index);
    });

    gallery.addEventListener('cellSelect', function () {
      var galleryData = themeDom.flickityData(gallery);
      if (!galleryData) return;
      themeDom.qsa('.is-nav-selected', carousel).forEach(function (n) {
        n.classList.remove('is-nav-selected');
      });
      var navCell = carousel.querySelector('.gallery-cell:nth-child(' + (galleryData.selectedIndex + 1) + ')');
      if (navCell) navCell.classList.add('is-nav-selected');
    });
  },
  fullWidth: function (images, imageContainer) {
    themeDom.qsa(images).forEach(function (img) {
      var alt = img.getAttribute('alt') || '';
      var src = img.getAttribute('src');

      if (alt.indexOf('[') < 0) return;

      img.remove();

      var shortcodes = alt.match(/\[(.*?)\]/ig);
      alt = alt.replace(/\[(.*?)\]/ig, '');

      var captionClass = shortcodes
        ? shortcodes.map(function (value) {
          return value.replace(/[\[\]']+/g, '');
        })
        : [];

      var cc = captionClass.length ? captionClass : 'center';

      var caption = [
        '<div class="position-' + cc + ' caption js-caption">',
        '<div class="caption-content caption-background-false align-' + cc + '">',
        '<p class="headline">' + alt + '</p>',
        '</div>',
        '</div>'
      ].join('');

      img.setAttribute('alt', alt);
      img.setAttribute('class', 'lazyload ' + Shopify.theme_settings.image_loading_style);
      img.setAttribute('src', src);
      img.setAttribute('data-sizes', 'auto');

      var outer = img.outerHTML;
      var banner = '<div class="banner">' + outer + caption + '</div>';

      var ic = themeDom.qs(imageContainer);
      if (ic) ic.insertAdjacentHTML('beforeend', banner);
    });
  },
  showSecondaryImage: function () {
    document.body.addEventListener('mouseover', function (e) {
      var t = e.target.closest('.swap-true');
      if (t) t.classList.add('toggle-images');
    });
    document.body.addEventListener('mouseout', function (e) {
      var t = e.target.closest('.swap-true');
      var rel = e.relatedTarget;
      if (t && (!rel || !t.contains(rel))) t.classList.remove('toggle-images');
    });
  }
}



var recentlyViewed = {
  init: function () {

    var productHandle,
      rvCookie,
      rvProducts,
      displayProducts,
      rvProductArray;

    if (themeDom.qs('.js-product_section[data-rv-handle]')) {
      productHandle = themeDom.qs('.js-product_section').dataset.rvHandle.toString();
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if (themeDom.qs('.recently-viewed__section')) {
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if (themeDom.qs('.collection-template-section .js-sidebar-recently-viewed')) {
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    }

    if (rvProducts) {
      rvProductArray = unescape(rvProducts).split(',').filter(Boolean);
    }

    if (productHandle) {
      if (!rvProductArray) {
        rvProductArray = [];
      }
      var existingIx = rvProductArray.indexOf(productHandle);
      if (existingIx !== -1) {
        rvProductArray.splice(existingIx, 1);
      }
      rvProductArray.unshift(productHandle);
      displayProducts = [];
      rvProductArray.forEach(function (el) {
        if (el && displayProducts.indexOf(el) === -1) {
          displayProducts.push(el);
        }
      });
      recentlyViewed.setCookieProducts(displayProducts);
    } else {
      displayProducts = rvProductArray ? rvProductArray.slice() : [];
    }

    if (themeDom.qs('.recently-viewed__section')) {
      var parent = '.recently-viewed__section';
      recentlyViewed.getProductInformation(parent, displayProducts);
    } else if (themeDom.qs('.js-recently-viewed .rv-main')) {
      var parent = '.js-recently-viewed';
      recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    }

    if (themeDom.qs('.sidebar .js-sidebar-recently-viewed')) {
      var parentSidebar = '.sidebar .js-sidebar-recently-viewed';
      if (productHandle) {
        recentlyViewed.getProductInformation(parentSidebar, displayProducts, productHandle);
      } else {
        recentlyViewed.getProductInformation(parentSidebar, displayProducts);
      }
      themeDom.qsa('.js-sidebar-recently-viewed.hidden').forEach(function (el) {
        var sb = el.closest('.sidebar-block');
        if (sb) sb.style.display = 'none';
      });
    }

  },
  getCookieProducts: function (rvCookie, productHandle) {

    if (!rvCookie && productHandle) {
      Cookies.set('recentlyViewed', productHandle, { expires: 30, path: '/' });
      rvCookie = Cookies.get('recentlyViewed');
    } else {
      rvCookie = Cookies.get('recentlyViewed');
    }

    return rvCookie;

  },
  setCookieProducts: function (rvProductArray) {
    Cookies.set('recentlyViewed', escape(rvProductArray.join(',')), { expires: 30, path: '/' });
  },
  getProductInformation: function (parent, displayProducts, productHandle) {

    if (!displayProducts || !displayProducts.length) {
      return;
    }

    if (productHandle) {
      var rvRemoveIx = displayProducts.indexOf(productHandle);
      if (rvRemoveIx !== -1) displayProducts.splice(rvRemoveIx, 1);
    }

    if (!displayProducts.length) {
      return;
    }

    var parentRoot = themeDom.qs(parent);
    var productLimit = parentRoot && parentRoot.dataset.visibleProducts != null
      ? parseInt(parentRoot.dataset.visibleProducts, 10)
      : null;

    var handles = displayProducts.slice();
    if (productLimit) {
      handles = handles.slice(0, productLimit);
    }

    if (!handles.length) {
      return;
    }

    var pRootUnhide = themeDom.qs(parent);
    if (pRootUnhide) {
      pRootUnhide.classList.remove('hidden');
      var sblock = pRootUnhide.closest('.sidebar-block');
      if (sblock) sblock.style.display = '';
    }

    var promises = handles.map(function (value, index) {
      if (!value) return Promise.resolve(null);
      return themeDom.fetchHtml('/products/' + encodeURIComponent(value) + '?view=rv').then(function (data) {
        return { index: index, data: data };
      }).catch(function (err) {
        console.log(err);
        return null;
      });
    });

    Promise.all(promises).then(function (results) {
      results.forEach(function (res) {
        if (!res || !res.data) return;
        var doc = themeDom.parseHtmlDoc(res.data);
        var rvProduct = doc.querySelector('.js-recently-viewed-product');
        var box = themeDom.qs(parent + ' .rv-box-' + res.index);
        if (box && rvProduct) {
          box.appendChild(document.importNode(rvProduct, true));
        }
      });

      var count = handles.filter(Boolean).length;
      var lim = productLimit || count;
      var rvMain = themeDom.qs(parent + ' .rv-main');
      if (rvMain && rvMain.classList.contains('js-rv-slider')) {
        var startIdx = count <= lim ? count : lim;
        themeDom.qsa(parent + ' .js-rv-slider .gallery-cell').forEach(function (cell, ci) {
          if (ci >= startIdx) cell.remove();
        });
        recentlyViewed.createSlider(parent, lim);
      } else if (rvMain && rvMain.classList.contains('js-rv-grid')) {
        var startIdxG = count <= lim ? count : lim;
        themeDom.qsa(parent + ' .js-rv-grid .thumbnail').forEach(function (thumb, ti) {
          if (ti >= startIdxG) thumb.remove();
        });
      }
    });
  },

  createSlider: function (parentSelector, productsAvailable) {

    var rvSlider = parentSelector
      ? themeDom.qs(parentSelector + ' .js-rv-slider')
      : themeDom.qs('.js-rv-slider');
    if (!rvSlider) return;

    var products_per_slide = parseInt(rvSlider.getAttribute('data-products-per-slide'), 10) || 0;
    var products_limit = parseInt(rvSlider.getAttribute('data-products-limit'), 10) || 0;
    var products_available = productsAvailable;
    var rvProductstoShow = themeDom.qsa('.gallery-cell', rvSlider);
    var cellAlign,
      draggable,
      prevNext,
      wrapAround,
      initialIndex;

    if (products_per_slide == 2 && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == 4 && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == 6 && products_available > products_per_slide && products_limit > products_per_slide) {
      cellAlign = "left";
    } else {
      cellAlign = "center";
    }

    if (products_available > products_per_slide && products_limit > products_per_slide) {
      draggable = true;
      prevNext = true;
      wrapAround = true;
    } else {
      draggable = false;
      prevNext = false;
      wrapAround = false;
    }

    if (products_per_slide == 2 && products_available > products_per_slide || products_per_slide == 4 && products_available > products_per_slide || products_per_slide == 6 && products_available > products_per_slide) {
      initialIndex = 0;
    } else if (products_per_slide == 3 && products_available) {
      initialIndex = 1;
    } else if (products_per_slide == 5 && products_available) {
      initialIndex = 2;
    } else if (products_per_slide == 7 && products_available) {
      initialIndex = 3;
    }

    if (themeDom.windowWidth() <= 798) {

      cellAlign = "center";
      initialIndex = 1;

      if (rvProductstoShow.length <= 2) {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      } else if (products_available > 3 && products_limit > 3) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      var ens = rvSlider.closest('.even-num-slides');
      if (ens) ens.classList.remove('even-num-slides');
    }

    if (rvSlider.classList.contains('slider-initialized')) {
      themeDom.flickityDestroy(rvSlider);
    }

    themeDom.flickityCreate(rvSlider, {
      lazyLoad: 2,
      imagesLoaded: true,
      draggable: draggable,
      prevNextButtons: prevNext,
      wrapAround: wrapAround,
      cellAlign: cellAlign,
      pageDots: usePageDots,
      contain: true,
      freeScroll: true,
      arrowShape: arrowSize,
      initialIndex: initialIndex
    });

    rvSlider.classList.add('slider-initialized');
  }
}



var featuredCollectionSection = {
  init: function () {
    themeDom.qsa('.js-product-slider .products-slider').forEach(function (sliderEl) {
      var products_per_slide = parseInt(sliderEl.getAttribute('data-products-per-slide'), 10) || 0;
      var products_limit = parseInt(sliderEl.getAttribute('data-products-limit'), 10) || 0;
      var products_available = parseInt(sliderEl.getAttribute('data-products-available'), 10) || 0;
      var slideshowSpeed = parseFloat(sliderEl.getAttribute('data-slideshow-speed')) * 1000;
      var cellAlign,
        draggable,
        prevNext,
        wrapAround,
        initialIndex;

      if (products_per_slide == 2 && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == 4 && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == 6 && products_available > products_per_slide && products_limit > products_per_slide) {
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == 2 && products_available > products_per_slide || products_per_slide == 4 && products_available > products_per_slide || products_per_slide == 6 && products_available > products_per_slide) {
        initialIndex = 0;
      } else if (products_per_slide == 3 && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == 5 && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == 7 && products_available) {
        initialIndex = 3;
      }

      if (themeDom.windowWidth() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        var ens = sliderEl.closest('.even-num-slides');
        if (ens) ens.classList.remove('even-num-slides');
      }

      themeDom.flickityCreate(sliderEl, {
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: draggable,
        prevNextButtons: prevNext,
        wrapAround: wrapAround,
        cellAlign: cellAlign,
        pageDots: usePageDots,
        contain: true,
        freeScroll: true,
        autoPlay: slideshowSpeed,
        arrowShape: arrowSize,
        initialIndex: initialIndex
      });

      sliderEl.classList.add('slider-initialized');
      sliderEl.classList.remove('slider-loading');
    });
  },
  unload: function ($target) {
    var root = themeDom.el($target);
    var slider = root && root.querySelector('.js-product-slider');
    if (slider && slider.classList.contains('flickity-enabled')) {
      themeDom.flickityDestroy(slider);
    }
  }
}

var featuredPromotions = {
  init: function () {
    if (themeDom.windowWidth() > 798 || themeDom.windowWidth() == 0) {
      var detailEaseMs = 280;
      themeDom.qsa('.feature-overlay').forEach(function (overlay) {
        overlay.addEventListener('mouseenter', function () {
          var det = overlay.querySelector('.feature-details');
          if (!det) return;
          det.style.display = 'block';
          det.style.overflow = 'hidden';
          var h = det.scrollHeight;
          det.style.maxHeight = '0';
          det.style.transition = 'max-height ' + detailEaseMs + 'ms ease';
          requestAnimationFrame(function () {
            det.style.maxHeight = h + 'px';
          });
          setTimeout(function () {
            det.classList.add('reveal-details');
            det.style.maxHeight = '';
          }, detailEaseMs);
        });
        overlay.addEventListener('mouseleave', function () {
          var det = overlay.querySelector('.feature-details');
          if (!det) return;
          det.classList.remove('reveal-details');
          det.style.transition = 'max-height ' + detailEaseMs + 'ms ease';
          det.style.maxHeight = '0';
          setTimeout(function () {
            det.style.display = 'none';
            det.style.maxHeight = '';
            det.style.transition = '';
          }, detailEaseMs);
        });
      });

      themeDom.qsa('.js-featured-promotions').forEach(function (promosEl) {
        var animationStyle = promosEl.getAttribute('data-promo-animation') || '';
        themeDom.onRevealPct(promosEl, 70, function () {
          themeDom.qsa('.feature-section', promosEl).forEach(function (fs) {
            fs.classList.add('animated');
            if (!animationStyle) return;
            var bottomStrip = fs.querySelector('.feature-wrap.bottom.black-strip');
            animationStyle.split(/\s+/).forEach(function (c) {
              if (!c) return;
              if (bottomStrip && /^fadeIn(Down|Up|Left|Right)$/.test(c)) {
                fs.classList.add('fadeIn');
              } else {
                fs.classList.add(c);
              }
            });
          });
        });
      });
    }
  }
}



var slideshow = {
  init: function () {

    themeDom.qsa('.js-homepage-slideshow').forEach(function (homepageSliderEl) {
      var settings = {
        slideshowSpeed: parseFloat(homepageSliderEl.getAttribute('data-slideshow-speed')) * 1000,
        slideshowArrowControl: homepageSliderEl.getAttribute('data-slideshow-arrow-control') !== 'false',
        slideshowTextAnimation: homepageSliderEl.getAttribute('data-slideshow-text-animation') || ''
      };


      if (!homepageSliderEl.classList.contains('flickity-enabled')) {
        var arrowShow = themeDom.qsa('.gallery-cell', homepageSliderEl).length === 1 ? false : true;
        themeDom.flickityCreate(homepageSliderEl, {
          wrapAround: true,
          cellAlign: 'left',
          imagesLoaded: true,
          prevNextButtons: settings.slideshowArrowControl,
          draggable: arrowShow,
          pageDots: usePageDots,
          autoPlay: settings.slideshowSpeed,
          arrowShape: arrowSize
        });

        if (settings.slideshowTextAnimation != '') {
          var animToken = settings.slideshowTextAnimation;
          setTimeout(function () {
            var cap = homepageSliderEl.querySelector('.gallery-cell:nth-child(1) .caption-content');
            if (cap) {
              cap.classList.add('animated');
              animToken.split(/\s+/).forEach(function (c) { if (c) cap.classList.add(c); });
            }
          }, 400);

          homepageSliderEl.addEventListener('cellSelect', function () {
            if (themeDom.isVisible(homepageSliderEl)) {
              var fd = themeDom.flickityData(homepageSliderEl);
              var currentSlide = fd ? fd.selectedIndex + 1 : 1;
              setTimeout(function () {
                themeDom.qsa('.caption-content', homepageSliderEl).forEach(function (cc) {
                  cc.classList.remove('animated');
                  animToken.split(/\s+/).forEach(function (c) { if (c) cc.classList.remove(c); });
                });
                var activeCap = homepageSliderEl.querySelector('.gallery-cell:nth-child(' + currentSlide + ') .caption-content');
                if (activeCap) {
                  activeCap.classList.add('animated');
                  animToken.split(/\s+/).forEach(function (c) { if (c) activeCap.classList.add(c); });
                }
              }, 400);
            }
          });
        }
      }

      if (themeDom.qsa('.gallery-cell', homepageSliderEl).length > 1) {
        homepageSliderEl.classList.add('multi-image');
      } else {
        homepageSliderEl.classList.add('single-image');
      }

      themeDom.qsa('.gallery-cell', homepageSliderEl).forEach(function (cell) {
        var buttonWidth = 0;
        themeDom.qsa('.action_button', cell).forEach(function (btn) {
          var w = btn.offsetWidth;
          if (w > buttonWidth) buttonWidth = w;
        });
        themeDom.qsa('.action_button', cell).forEach(function (btn) {
          btn.style.width = buttonWidth + 'px';
        });
      });

    });
  },
  unload: function ($target) {

    var root = themeDom.el($target);
    var slider = root && root.querySelector('.js-homepage-slideshow');
    if (slider) themeDom.flickityDestroy(slider);

  }
}



var testimonial = {
  init: function () {

    themeDom.qsa('.js-testimonial').forEach(function (testimonialSliderEl) {
      var settings = {
        slideshowSpeed: parseFloat(testimonialSliderEl.getAttribute('data-slideshow-speed')) * 1000,
        slideshowTextAnimation: testimonialSliderEl.getAttribute('data-slideshow-text-animation') || ''
      };

      if (themeDom.qsa('.testimonial-image').length > 0) {
        themeDom.qsa('.testimonial-block').forEach(function (block) {
          if (themeDom.qsa('.testimonial-image', block).length === 0) {
            var theBlock = block.closest('.testimonial-block');
            if (theBlock) theBlock.classList.add('set-testimonial-height');
          }
        });
      }


      if (!testimonialSliderEl.classList.contains('flickity-enabled')) {
        var arrowShow = themeDom.qsa('.gallery-cell', testimonialSliderEl).length === 1 ? false : true;
        themeDom.flickityCreate(testimonialSliderEl, {
          wrapAround: true,
          cellAlign: 'left',
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          pageDots: usePageDots,
          autoPlay: settings.slideshowSpeed,
          arrowShape: arrowSize
        });

        if (settings.slideshowTextAnimation != '') {
          var animT = settings.slideshowTextAnimation;
          setTimeout(function () {
            var cap = testimonialSliderEl.querySelector('.gallery-cell:nth-child(1) .caption-content');
            if (cap) {
              cap.classList.add('animated');
              animT.split(/\s+/).forEach(function (c) { if (c) cap.classList.add(c); });
            }
          }, 400);

          testimonialSliderEl.addEventListener('cellSelect', function () {
            if (themeDom.isVisible(testimonialSliderEl)) {
              var fd = themeDom.flickityData(testimonialSliderEl);
              var currentSlide = fd ? fd.selectedIndex + 1 : 1;
              setTimeout(function () {
                themeDom.qsa('.caption-content', testimonialSliderEl).forEach(function (cc) {
                  cc.classList.remove('animated');
                  animT.split(/\s+/).forEach(function (c) { if (c) cc.classList.remove(c); });
                });
                var activeCap = testimonialSliderEl.querySelector('.gallery-cell:nth-child(' + currentSlide + ') .caption-content');
                if (activeCap) {
                  activeCap.classList.add('animated');
                  animT.split(/\s+/).forEach(function (c) { if (c) activeCap.classList.add(c); });
                }
              }, 400);
            }
          });
        }
      }

      if (themeDom.qsa('.gallery-cell', testimonialSliderEl).length > 1) {
        testimonialSliderEl.classList.add('multi-image');
      } else {
        testimonialSliderEl.classList.add('single-image');
      }

      themeDom.qsa('.gallery-cell', testimonialSliderEl).forEach(function (cell) {
        var buttonWidth = 0;
        themeDom.qsa('.action_button', cell).forEach(function (btn) {
          var w = btn.offsetWidth;
          if (w > buttonWidth) buttonWidth = w;
        });
        themeDom.qsa('.action_button', cell).forEach(function (btn) {
          btn.style.width = buttonWidth + 'px';
        });
      });

    });
  },

  unload: function ($target) {
    var root = themeDom.el($target);
    var slider = root && root.querySelector('.js-testimonial');
    if (slider) themeDom.flickityDestroy(slider);

  }
}



var gallery = {
  init: function () {

    themeDom.qsa('.gallery-horizontal .gallery-image-wrapper').forEach(function (wrapper) {
      var images = wrapper.querySelectorAll('img');
      if (!images.length) return;
      var firstSrc = images[0].getAttribute('src');
      var preload = new Image();
      preload.onload = function () {
        var imgWidth = preload.width;
        var imgHeight = preload.height;
        wrapper.style.flexBasis = (imgWidth * 200 / imgHeight) + 'px';
        wrapper.style.flexGrow = String(imgWidth * 200 / imgHeight);
        var iTag = wrapper.querySelector('i');
        if (iTag) iTag.style.paddingBottom = (imgHeight / imgWidth * 100) + '%';
      };
      preload.src = firstSrc;
    });


    lightboxGallery.init();

  }
}





var supports_video = function () {
  return !!document.createElement('video').canPlayType;
}

var videoSection = {
  _abortCtrl: null,

  init: function () {

    if (videoSection._abortCtrl) videoSection._abortCtrl.abort();
    videoSection._abortCtrl = new AbortController();
    var sig = videoSection._abortCtrl.signal;

    themeDom.qsa('.homepage-video').forEach(function (hv) {
      if (!supports_video()) return;

      var settings = videoSection.getVideoSettings(hv);

      if (is_touch_device() && themeDom.windowWidth() <= 798 && settings.posterImage === false || themeDom.windowWidth() <= 798 && settings.posterImage === false) {
        videoSection.appendFrame(hv, settings);
      } else if (settings.autoPlayVideo) {
        videoSection.appendFrame(hv, settings);
      } else if (settings.autoPlayVideo === false && settings.posterImage === false) {
        videoSection.appendFrame(hv, settings);
      } else {
        themeDom.qsa('.homepage-video__placeholder', hv).forEach(function (el) { themeDom.show(el); });
        themeDom.qsa('.placeholder-svg--video', hv).forEach(function (el) { themeDom.show(el); });
      }
    });

    document.body.addEventListener('click', function (e) {
      var playBtn = e.target.closest('.video__play-button');
      if (playBtn) {
        var sec = playBtn.closest('.video-section');
        var hv = sec ? sec.querySelector('.homepage-video') : null;
        if (!hv) return;
        themeDom.fadeOut(playBtn);
        var settings = videoSection.getVideoSettings(hv);
        if (!themeDom.qs('.mediaWrapper', hv) && !hv.querySelector('video')) {
          videoSection.appendFrame(hv, settings);
        }
        return;
      }
      var dpv = e.target.closest('[data-play-video]');
      if (dpv) {
        var sec2 = dpv.closest('.video-section');
        var hv2 = sec2 ? sec2.querySelector('.homepage-video') : null;
        if (!hv2) return;
        themeDom.fadeOut(dpv);
        var settings2 = videoSection.getVideoSettings(hv2);
        if (!themeDom.qs('.mediaWrapper', hv2) && !hv2.querySelector('video')) {
          videoSection.appendFrame(hv2, settings2);
        }
      }
    }, { capture: false, signal: sig });
  },

  getVideoSettings: function (videoEl) {
    var parseBoolAttr = function (name) {
      var raw = videoEl.getAttribute(name);
      if (raw === 'false') return false;
      if (raw === 'true') return true;
      return raw;
    };
    return {
      container: themeDom.qs('.homepage-video', videoEl) || videoEl,
      header: themeDom.qs('.homepage-video--media', videoEl),
      posterImage: parseBoolAttr('data-poster-image'),
      videoText: themeDom.qs('.homepage-video--media .caption', videoEl),
      videoTrigger: themeDom.qs('[data-play-video]', videoEl),
      autoPlayVideo: parseBoolAttr('data-autoplay'),
      displayTextOverVideo: parseBoolAttr('data-display-text-over-video'),
      autoloop: parseBoolAttr('data-autoloop'),
      id: videoEl.getAttribute('data-video-src'),
      aspectRatio: (videoEl.getAttribute('data-aspect-ratio') || '16:9').split(':'),
      provider: (videoEl.getAttribute('data-provider') || '').toLowerCase(),
      videoMP4: videoEl.getAttribute('data-video-mp4'),
      videoOGV: videoEl.getAttribute('data-video-ogv')
    };
  },

  createFrame: function (settings) {
    var autoloop,
      controls,
      html,
      autoplay,
      autobuffer,
      muted,
      playsinline,
      poster = '',
      sourcevideoMP4,
      sourcevideoOGV;

    if (settings.provider === 'youtube') {
      if (settings.autoloop) {
        autoloop = '1&iv_load_policy=3&playlist=' + settings.id;
      } else {
        autoloop = 0;
      }

      if (settings.posterImage === false && settings.autoPlayVideo === false) {
        autoplay = 0;
      } else {
        autoplay = 1;
      }

      controls = 1;

      html = '<iframe src="//www.youtube.com/embed/' + settings.id + '?&autoplay=' + autoplay + '&loop=' + autoloop + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }

    else if (settings.provider === 'vimeo') {

      if (settings.posterImage === false && settings.autoPlayVideo === false) {
        autoplay = 0;
      } else {
        autoplay = 1;
      }

      if (settings.autoloop) {
        autoloop = 1;
      } else {
        autoloop = 0;
      }
      html = '<iframe src="//player.vimeo.com/video/' + settings.id + '?loop=' + autoloop + '&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=' + autoplay + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }

    else if (settings.provider === 'html5') {

      if (settings.posterImage !== false) {
        poster = ' poster="https://' + settings.posterImage + '"';
      }
      else {
        poster = ' '
      }

      if (settings.autoPlayVideo === false && is_touch_device() === 0) {
        autoplay = ' ';
      } else {
        autoplay = ' autoplay ';
      }

      if (settings.autoloop) {
        autoloop = ' loop ';
      }
      else {
        autoloop = ' ';
      }

      if (settings.videoMP4) {
        sourcevideoMP4 = '<source src="' + settings.videoMP4 + '" type="video/mp4">';
      }
      else {
        sourcevideoMP4 = ' ';
      }

      if (settings.videoOGV) {
        sourcevideoOGV = '<source src="' + settings.videoOGV + '" type="video/ogg">';
      }
      else {
        sourcevideoOGV = ' ';
      }
      autobuffer = ' autobuffer ';
      playsinline = ' playsinline ';

      html = '<video preload="true" id="video" onclick="this.paused?this.play():this.pause();" ' + autobuffer + playsinline + autoplay + autoloop + poster + '>' + sourcevideoMP4 + sourcevideoOGV + '</video>';
    }

    return html;
  },

  appendFrame: function (videoWrap, settings) {

    if (settings.displayTextOverVideo === false && settings.videoText) {
      themeDom.fadeOut(settings.videoText);
    }

    themeDom.qsa('.video__play-button', videoWrap).forEach(function (b) { themeDom.fadeOut(b); });

    videoWrap.insertAdjacentHTML('beforeend', videoSection.createFrame(settings));

    if (settings.provider != 'html5') {
      var paddingBottomValue = settings.aspectRatio[1] / settings.aspectRatio[0] * 100 + '%';

      themeDom.qsa('iframe', videoWrap).forEach(function (fr) {
        themeDom.jqMediaWrapper(fr, {
          intrinsic: false,
          baseWidth: settings.aspectRatio[0],
          baseHeight: settings.aspectRatio[1]
        });
      });

      themeDom.css(videoWrap, {
        height: '0',
        paddingBottom: paddingBottomValue
      });

    } else {
      themeDom.qsa('.homepage-video__image', videoWrap).forEach(function (im) { themeDom.hide(im); });
    }
  },

  unload: function () {
    if (videoSection._abortCtrl) {
      videoSection._abortCtrl.abort();
      videoSection._abortCtrl = null;
    }
  }
}

var cart = {
  init: function () {
    if (themeDom.qs('#cart_form .tos_agree')) {
      themeDom.delegate(document.body, 'click', "#cart_form input[type='submit']", function (e) {
        var form = this.closest('form');
        var tos = form ? form.querySelector('.tos_agree') : null;
        if (tos && tos.checked) {
          if (form && form.submit) form.submit();
        } else {
          var warning = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + '</p>';
          if (!themeDom.qs('p.warning')) {
            this.insertAdjacentHTML('beforebegin', warning);
          }
          e.preventDefault();
        }
      });
    }
  }
}



selectCallback = function (variant, selector) {
  var productRoot = themeDom.qs('.product-' + selector.product.id);
  var notifyFormEl = themeDom.qs('.notify-form-' + selector.product.id);
  var productForm = themeDom.qs('form.product_form', productRoot);
  var variantInventory = productForm ? themeDom.dataAttr(productForm, 'variantInventory') : null;
  var notifyFormInputsWrap = themeDom.qs('.notify_form__inputs');

  var notifyEmail = Shopify.translation.notify_email;
  var notifyEmailValue = Shopify.translation.notify_email_value;
  var notifySend = Shopify.translation.notify_email_send;

  var notifyUrl = Shopify.theme_settings.site_url + '/products/' + selector.product.handle;

  var variantTitle = variant ? variant.name.replace(/"/g, '\&quot;') : '37';

  var notifyMessage = '';
  if (variant) {
    notifyMessage = Shopify.translation.notify_message_first + variantTitle + Shopify.translation.notify_message_last + notifyUrl;
  }
  var notifyEmailInput;
  if (notifyFormInputsWrap && notifyFormInputsWrap.classList.contains('customer--true')) {
    var notifyCustomerEmail = notifyFormEl ? notifyFormEl.dataset.customerEmail : '';
    notifyEmailInput = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="' + notifyCustomerEmail + '" />';
  } else {
    notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="' + notifyEmail + '" value="' + notifyEmailValue + '" />';
  }
  var notifyFormHTML = notifyEmailInput + '<input type="hidden" name="challenge" value="true" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="' + notifyMessage + '" value="' + notifyMessage + '" /><input class="action_button" type="submit" value="' + notifySend + '" style="margin-bottom:0px" />';

  var moneyFormat = productForm ? themeDom.dataAttr(productForm, 'moneyFormat') : null;
  if (typeof moneyFormat !== 'string' && productForm) {
    moneyFormat = productForm.getAttribute('data-money-format');
  }

  if (variant && variant.featured_image && productRoot && themeDom.isVisible(productRoot)) {
    themeDom.qsa('.product_gallery', productRoot).forEach(function (sliderEl) {
      var sliderInstance = window.Flickity && window.Flickity.data(sliderEl);
      if (themeDom.isVisible(sliderEl) && sliderInstance) {
        var imgMarker = themeDom.qs('[data-image-id="' + variant.featured_image.id + '"]');
        var index = imgMarker ? parseInt(imgMarker.getAttribute('data-index'), 10) : 0;
        sliderInstance.select(index, false, true);
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function (v) {
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    var skuSpan = themeDom.qs('.sku span', productRoot);
    if (skuSpan) skuSpan.textContent = variant.sku;

    if (Shopify.theme_settings.product_form_style === "swatches") {
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var sel = '.swatch[data-option-index="' + String(i) + '"] input[type="radio"][value="' + variant.options[i].replace(/"/g, '\\"') + '"]';
        var radioButton = themeDom.qs(sel, productRoot);
        if (radioButton) radioButton.checked = true;
      }
    } else {
      var nfm = themeDom.qs('.notify_form_message', productRoot);
      var bodyBase = nfm ? nfm.getAttribute('data-body') : '';
      if (nfm) nfm.setAttribute('value', bodyBase + ' - ' + variant.title);
    }
  }

  if (variant && variant.available) {
    if (variant.price < variant.compare_at_price) {
      themeDom.html(themeDom.qs('.was_price', productRoot), '<span class="money">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</span>');
      themeDom.html(themeDom.qs('.savings', productRoot), Shopify.translation.savings_text + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, moneyFormat) + '</span>)');
    } else {
      if (typeof PXUTheme !== 'undefined' && PXUTheme.discountRowHidden()) {
        themeDom.html(themeDom.qs('.was_price', productRoot), '');
        themeDom.html(themeDom.qs('.savings', productRoot), '');
      }
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      if (Shopify.theme_settings.display_inventory_left) {
        var items_left_text = variant.inventory_quantity == 1
          ? Shopify.translation.one_item_left
          : Shopify.translation.items_left_text;
        themeDom.html(themeDom.qs('.items_left', productRoot), "<p><em>" + variant.inventory_quantity + " " + items_left_text + "</em></p>");
      }
      if (Shopify.theme_settings.limit_quantity) {
        if (variant.inventory_policy == "deny") {
          var qtyEl = themeDom.qs('.quantity', productRoot);
          if (qtyEl) qtyEl.setAttribute('max', variant.inventory_quantity);
        }
      }
    } else {
      themeDom.text(themeDom.qs('.items_left', productRoot), '');
      var qtyEl2 = themeDom.qs('.quantity', productRoot);
      if (qtyEl2) qtyEl2.removeAttribute('max');
    }

    if (variant.price > 0) {
      themeDom.html(themeDom.qs('.current_price', productRoot), '<span class="money">' + Shopify.formatMoney(variant.price, moneyFormat) + '</span>');
    } else {
      themeDom.html(themeDom.qs('.current_price', productRoot), Shopify.theme_settings.free_text);
    }

    themeDom.qsa('.add_to_cart', productRoot).forEach(function (btn) {
      btn.classList.add('custom-color');
      btn.classList.remove('disabled');
      btn.removeAttribute('disabled');
      var span = btn.querySelector('span');
      var addBtn = themeDom.qs('.add_to_cart', productRoot);
      var label = addBtn ? themeDom.dataAttr(addBtn, 'label') : null;
      if (!label && addBtn) label = addBtn.getAttribute('data-label');
      if (span && label) span.textContent = label;
    });
    if (themeDom.qs('.block-content-option')) {
      themeDom.qsa('.block-content-option').forEach(function (el) { el.classList.remove('hidden'); });
    }
    if (notifyFormEl) themeDom.hide(notifyFormEl);

    var qtyRaw = variant.inventory_quantity;
    var qtyNum = qtyRaw == null || qtyRaw === '' ? null : Number(qtyRaw);
    var usePreOrderModal = !!(
      variant.inventory_management &&
      variant.inventory_policy === 'continue' &&
      qtyNum !== null &&
      !isNaN(qtyNum) &&
      qtyNum < 1
    );

    if (!usePreOrderModal) {
      themeDom.qsa('.add_to_cart', productRoot).forEach(function (btn) {
        btn.classList.remove('pre-order');
      });
    }

    if (variant.inventory_policy == "deny") {
      themeDom.hide(themeDom.qs('#pre-order-old'));
      themeDom.hide(themeDom.qs('#pre-order-old-des'));
      themeDom.qsa('.pre_order_note').forEach(function (el) { themeDom.hide(el); });
      themeDom.text(themeDom.qs('.sold_out', productRoot), '');
      themeDom.qsa('.add_to_cart', productRoot).forEach(function (btn) {
        btn.classList.remove('pre-order');
        btn.classList.remove('disabled');
        btn.removeAttribute('disabled');
        var span = btn.querySelector('span');
        var lblEl = themeDom.qs('.add_to_cart', productRoot);
        var lb = lblEl ? (themeDom.dataAttr(lblEl, 'label') || lblEl.getAttribute('data-label')) : '';
        if (span && lb) span.textContent = lb;
      });
    }
    if (usePreOrderModal) {
      themeDom.show(themeDom.qs('#pre-order-old'), 'block');
      themeDom.show(themeDom.qs('#pre-order-old-des'), 'block');
      themeDom.qsa('.pre_order_note').forEach(function (el) { themeDom.show(el); });
      themeDom.qsa('.add_to_cart', productRoot).forEach(function (btn) {
        btn.classList.add('pre-order');
        btn.classList.remove('disabled');
        btn.removeAttribute('disabled');
        var span = btn.querySelector('span');
        if (span) span.textContent = 'pre-order';
      });
      if (productRoot && !productRoot.dataset.preOrderModalBound) {
        productRoot.dataset.preOrderModalBound = '1';
        themeDom.delegate(productRoot, 'click', '.pre-order', function (e) {
          e.preventDefault();
          themeDom.remodalOpen('[data-remodal-id=pre-order-button]');
          var popupBtn = themeDom.qs('[data-remodal-id=pre-order-button] .pre-order-popup-button');
          if (popupBtn) {
            popupBtn.addEventListener('click', function onPopupClick(e2) {
              e2.preventDefault();
              if (productForm) {
                if (typeof productForm.requestSubmit === 'function') {
                  try {
                    productForm.requestSubmit();
                  } catch (submitErr) {
                    productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                  }
                } else {
                  productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
              }
              setTimeout(function () { themeDom.remodalClose('[data-remodal-id=pre-order-button]'); }, 900);
            }, { once: true });
          }
        });
      }
    }
    if (variant.inventory_policy == "continue" && qtyNum !== null && !isNaN(qtyNum) && qtyNum >= 1) {
      themeDom.hide(themeDom.qs('#pre-order-old'));
      themeDom.hide(themeDom.qs('#pre-order-old-des'));
      themeDom.qsa('.add_to_cart', productRoot).forEach(function (btn) {
        btn.classList.remove('pre-order');
        btn.classList.remove('disabled');
        btn.removeAttribute('disabled');
        var span = btn.querySelector('span');
        var lblEl = themeDom.qs('.add_to_cart', productRoot);
        var lb = lblEl ? (themeDom.dataAttr(lblEl, 'label') || lblEl.getAttribute('data-label')) : '';
        if (span && lb) span.textContent = lb;
      });
    }
  } else {
    var sw = themeDom.qs('.swatch_options .swatch', productRoot);
    var FirstOption = sw && sw.getAttribute('data-unavailable-label') ? sw.getAttribute('data-unavailable-label') : Shopify.translation.unavailable_text;
    var message = variant ? Shopify.translation.sold_out_text : FirstOption;
    var messageForgiftcard = variant ? Shopify.translation.sold_out_text : Shopify.translation.unavailable_for_gift_card_text;
    if (typeof PXUTheme !== 'undefined' && PXUTheme.discountRowHidden()) {
      themeDom.text(themeDom.qs('.was_price', productRoot), '');
      themeDom.text(themeDom.qs('.savings', productRoot), '');
    }
    themeDom.text(themeDom.qs('.items_left', productRoot), '');
    var qtyEl3 = themeDom.qs('.quantity', productRoot);
    if (qtyEl3) qtyEl3.removeAttribute('max');
    themeDom.qsa('.add_to_cart:not(.gift_card)', productRoot).forEach(function (btn) {
      btn.classList.add('disabled');
      btn.setAttribute('disabled', 'disabled');
      var span = btn.querySelector('span');
      if (span) span.textContent = message;
    });
    themeDom.qsa('.add_to_cart.gift_card', productRoot).forEach(function (btn) {
      btn.classList.add('disabled');
      btn.setAttribute('disabled', 'disabled');
      var span = btn.querySelector('span');
      if (span) span.textContent = messageForgiftcard;
    });
    if (window.location.search != '?contact_posted=true') {
      if (notifyFormEl) themeDom.hide(notifyFormEl);
    }
    if (notifyFormInputsWrap) notifyFormInputsWrap.innerHTML = '';

    if (variant && !variant.available) {
      if (notifyFormEl) themeDom.fadeIn(notifyFormEl, 120);
      if (notifyFormInputsWrap) {
        notifyFormInputsWrap.innerHTML = '';
        notifyFormInputsWrap.insertAdjacentHTML('beforeend', notifyFormHTML);
      }
    }
    if (variant) {
      themeDom.text(themeDom.qs('.sold_out', productRoot), message);
      themeDom.html(themeDom.qs('.current_price', productRoot), '<span class="money">' + Shopify.formatMoney(variant.price, moneyFormat) + '</span>');
    }
  }

  try {
    document.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: { variant: variant }
    }));
  } catch (variantEvErr) {}
};

var productPage = {
  init: function () {

    var draggable = true;
    var prevNextButtons = true;

    setTimeout(function () {
      var gal = themeDom.qs('.js-product-page-gallery .product_gallery');
      var nav = themeDom.qs('.js-product-page-gallery .product_gallery_nav');
      if (gal && nav) imageFunctions.linkGalleryAndCarousel(gal, nav);
    }, 1000);
    imageFunctions.zoom('.product_gallery', false);

    if (themeDom.qs('.js-full-width-product-images')) {
      imageFunctions.fullWidth('.product-template .product .description img', '.js-full-width-product-images');
    }

    var pgRoot = themeDom.qs('.product_gallery');
    if (pgRoot && pgRoot.classList.contains('single-image')) {
      draggable = false;
      prevNextButtons = false;
    }

    var autoplayEl = themeDom.qs('.product_gallery');
    var autoplay = autoplayEl ? themeDom.dataAttr(autoplayEl, 'autoplay') : null;
    if (autoplay == null && autoplayEl && autoplayEl.getAttribute('data-autoplay')) {
      autoplay = autoplayEl.getAttribute('data-autoplay');
    }

    themeDom.qsa('.product_gallery').forEach(function (galleryEl) {
      themeDom.flickityCreate(galleryEl, {
        wrapAround: true,
        cellAlign: "left",
        draggable: draggable,
        contain: true,
        imagesLoaded: true,
        lazyLoad: 2,
        pageDots: usePageDots,
        prevNextButtons: prevNextButtons,
        autoPlay: autoplay ? 6000 : false,
        selectedAttraction: 0.01,
        friction: 0.15,
        arrowShape: arrowSize
      });
    });

    themeDom.qsa('.js-product_section .product_form_options').forEach(function (optEl) {
      var sid = themeDom.dataAttr(optEl, 'selectId');
      if (!sid) sid = optEl.getAttribute('data-select-id');
      var prod = themeDom.dataAttr(optEl, 'product');
      var ens = themeDom.dataAttr(optEl, 'enableState');
      if (ens === undefined || ens === null) ens = optEl.getAttribute('data-enable-state');
      new Shopify.OptionSelectors(sid, { product: prod, onVariantSelected: selectCallback, enableHistoryState: ens });
    });

    if (window.location.search === '?contact_posted=true') {
      themeDom.qsa('.notify_form .contact-form').forEach(function (cf) { themeDom.hide(cf); });
      themeDom.qsa('.notify_form').forEach(function (nf) { themeDom.show(nf); });
      themeDom.qsa('.notify_form .contact-form').forEach(function (cf) {
        var prev = cf.previousElementSibling;
        if (prev && prev.classList.contains('message')) themeDom.html(prev, Shopify.translation.notify_success_text);
      });
    }

    themeDom.qsa('.notify_form .contact-form').forEach(function (nf) {
      nf.addEventListener('submit', function (e) {
        var ch = themeDom.qs('input[name="challenge"]', nf);
        if (!ch || ch.value !== "true") {
          themeDom.ajax({
            type: nf.getAttribute('method'),
            url: nf.getAttribute('action'),
            data: themeDom.serializeForm(nf),
            success: function () {
              themeDom.fadeOut(nf, 'slow', function () {
                var prev = nf.previousElementSibling;
                if (prev) themeDom.html(prev, Shopify.translation.notify_success_text);
              });
            },
            error: function () {
              if (ch) ch.value = 'true';
              nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    if (Shopify.theme_settings.product_form_style === "swatches") {
      themeDom.delegate(document.body, 'change', '.swatch input[type="radio"]', function () {
        var sw = this.closest('.swatch');
        var optionIndex = sw ? sw.getAttribute('data-option-index') : '0';
        var optionValue = this.value;
        var parentForm = this.closest('.product_form');
        if (!parentForm) return;

        var notifyForm = null;
        var par = parentForm.parentElement;
        if (par) {
          Array.prototype.forEach.call(par.children, function (c) {
            if (c !== parentForm && c.classList.contains('notify_form')) notifyForm = c;
          });
        }
        if (!notifyForm) notifyForm = themeDom.qs('.js-notify-form');

        var checked = themeDom.qsa('.swatch_options input:checked', parentForm);
        var option1 = checked[0] ? checked[0].value : '';
        var option2 = checked[1] ? checked[1].value : '';
        var option3 = checked[2] ? checked[2].value : '';

        var notifyMessage = option1 && option2 && option3
          ? option1 + ' / ' + option2 + ' / ' + option3
          : option1 && option2
            ? option1 + ' / ' + option2
            : option1;

        if (notifyForm) {
          var nfm = notifyForm.querySelector('.notify_form_message');
          var bodyStart = nfm ? nfm.getAttribute('data-body') : '';
          if (nfm) nfm.setAttribute('value', bodyStart + ' - ' + notifyMessage);
        }

        var selectors = parentForm.querySelectorAll('.single-option-selector');
        var ix = parseInt(optionIndex, 10);
        if (!isNaN(ix) && selectors[ix]) {
          selectors[ix].value = optionValue;
          themeDom.trigger(selectors[ix], 'change');
        }
      });
    }

    lightboxGallery.init();

  },
  relatedProducts: function () {

    themeDom.qsa('.js-related-products-slider .products-slider').forEach(function (sliderEl) {
      var products_per_slide = parseInt(sliderEl.getAttribute('data-products-per-slide'), 10) || 0;
      var products_limit = parseInt(sliderEl.getAttribute('data-products-limit'), 10) || 0;
      var products_available = parseInt(sliderEl.getAttribute('data-products-available'), 10) || 0;
      var cellAlign,
        draggable,
        prevNext,
        wrapAround,
        initialIndex;

      if (products_per_slide == 2 && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == 4 && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == 6 && products_available > products_per_slide && products_limit > products_per_slide) {
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == 2 && products_available > products_per_slide || products_per_slide == 4 && products_available > products_per_slide || products_per_slide == 6 && products_available > products_per_slide) {
        initialIndex = 0;
      } else if (products_per_slide == 3 && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == 5 && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == 7 && products_available) {
        initialIndex = 3;
      }

      if (themeDom.windowWidth() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        var ens = sliderEl.closest('.even-num-slides');
        if (ens) ens.classList.remove('even-num-slides');
      }

      themeDom.flickityCreate(sliderEl, {
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: draggable,
        cellAlign: cellAlign,
        prevNextButtons: prevNext,
        wrapAround: wrapAround,
        pageDots: usePageDots,
        contain: true,
        freeScroll: true,
        arrowShape: arrowSize,
        initialIndex: initialIndex
      });
    });
  },
  initializeQuantityBox: function () {

    themeDom.delegate(document.body, 'click', '.js-change-quantity', function () {
      var btn = this;
      var input = btn.parentElement ? btn.parentElement.querySelector('input') : null;
      if (!input) return;
      var val = parseInt(input.value, 10);
      var valMax = 100000;
      var valMin = input.getAttribute('min') || 0;

      if (input.getAttribute('max') != null) {
        valMax = input.getAttribute('max');
      }

      if (isNaN(val) || val < valMin) {
        input.value = valMin;
        return false;
      } else if (val > valMax) {
        input.value = valMax;
        return false;
      }

      var func = btn.getAttribute('data-func');
      if (func == 'plus') {
        if (val < valMax) input.value = String(val + 1);
      } else {
        if (val > valMin) input.value = String(val - 1);
        var inCart = btn.closest('.cart_item');
        if (inCart) {
          if (val - 1 == 0) {
            inCart.classList.add('animated', 'fadeOutUp');
          }
        }
      }
      themeDom.trigger(input, 'change');

    });
  },
  unload: function (target) {

    var root = themeDom.el(target);
    var slider = root && root.querySelector('.products-slider');
    if (slider) themeDom.flickityDestroy(slider);

  }
}



var newsletter_popup = {
  init: function () {
    var popup = Cookies.get('popup');
    var cookie_enabled = Shopify.theme_settings.newsletter_popup_cookie_enabled;

    if (cookie_enabled && popup == 'open') {
      return false;
    } else {
      newsletter_popup.open();
    }
    if (cookie_enabled) {
      Cookies.set('popup', 'open', { expires: Shopify.theme_settings.newsletter_popup_days });
    }
  },
  open: function () {
    var sereen_size = Shopify.theme_settings.newsletter_popup_mobile_breakpoint;

    if (themeDom.windowWidth() > sereen_size) {
      setTimeout(function () {
        themeDom.remodalOpen('[data-remodal-id=newsletter]');
      },
        Shopify.theme_settings.newsletter_popup_delay_ms);
    }
  }
}


var productpagenote_popup = {
  init: function () {
    var popup = Cookies.get('popup');
    var cookie_enabled = Shopify.theme_settings.productpage_popup_cookie_enabled;

    if (cookie_enabled && popup == 'open') {
      return false;
    } else {
      productpagenote_popup.open();
    }
    if (cookie_enabled) {
      Cookies.set('popup', 'open', { expires: Shopify.theme_settings.productpage_popup_note_delay_days });
    }
  },
  open: function () {
    var sereen_size = Shopify.theme_settings.productpage_popup_note_mobile_breakpoint;

    if (themeDom.windowWidth() > sereen_size) {
      setTimeout(function () {
        if (themeDom.qs('[data-remodal-id=show-popup-note]')) {
          themeDom.remodalOpen('[data-remodal-id=show-popup-note]');
        }
      },
        Shopify.theme_settings.productpage_popup_note_delay_ms);
    }
  }
}


var header = {
  init: function () {

    if (header._headerAbort) header._headerAbort.abort();
    header._headerAbort = new AbortController();
    var sig = header._headerAbort.signal;

    if (themeDom.qs('.promo_banner')) {
      var promo_banner = Cookies.get('promo_banner');

      if (promo_banner != 'dismiss') {
        document.body.classList.add('promo_banner-show');
        themeDom.qsa('.promo_banner').forEach(function (wrap) {
          wrap.addEventListener('click', function (e) {
            var close = e.target.closest('.promo_banner-close');
            if (!close) return;
            document.body.classList.remove('promo_banner-show');
            Cookies.set('promo_banner', 'dismiss', { expires: 1 });
          }, { signal: sig });
        });
      }
    }

    themeDom.qsa('.vertical-menu_submenu, .vertical-menu_sub-submenu').forEach(function (el) {
      if (themeDom.isOffRight(el)) {
        el.classList.add('vertical-menu--align-right');
      }
    });

    if (themeDom.windowWidth() > 1365) {
      var hdrFixed = themeDom.qs('.header.header-fixed--true');
      if (hdrFixed) {
        if (!themeDom.qs('.main_nav_wrapper.sticky_nav')) {

          new Headhesive('.main_nav_wrapper', {
            offset: 700,
            throttle: 300,
            classes: {
              clone: 'sticky_nav',
              stick: 'sticky_nav--stick',
              unstick: 'sticky_nav--unstick'
            },
            onInit: function () {
              themeDom.qsa('.sticky_nav .secondary_logo').forEach(function (el) { themeDom.hide(el); });
              themeDom.qsa('.sticky_nav .primary_logo').forEach(function (el) { themeDom.show(el); });
              themeDom.qsa('.sticky_nav .icon-search').forEach(function (el) { themeDom.show(el); });
              themeDom.qsa('.sticky_nav .search_container').forEach(function (el) { themeDom.hide(el); });
              var stickyNavs = themeDom.qsa('.sticky_nav .nav');
              var stickyNavLast = stickyNavs.length ? stickyNavs[stickyNavs.length - 1] : null;
              var cartSrc = themeDom.qs('.header .cart_container');
              if (stickyNavLast && cartSrc && stickyNavLast.prepend) {
                stickyNavLast.prepend(cartSrc.cloneNode(true));
              }
              var navSticky = themeDom.qs('.sticky_nav .nav');
              var sticky_nav_height = navSticky
                ? (Shopify.theme_settings.menu_position_inline ? navSticky.offsetHeight : navSticky.offsetHeight + 5)
                : 0;
              themeDom.qsa('.sticky_nav .mini_cart').forEach(function (el) { el.style.height = sticky_nav_height + 'px'; });
              themeDom.qsa('.sticky_nav .cart_content').forEach(function (el) { el.style.top = sticky_nav_height + 'px'; });
            },
            onUnstick: function () {
              themeDom.qsa('.cart_container').forEach(function (el) { el.classList.remove('active_link'); });
            }
          });
        }
      } else {
        themeDom.qsa('.header-fixed--true').forEach(function (el) { el.classList.remove('header-fixed--true'); });
        var wrappers = themeDom.qsa('.main_nav_wrapper');
        if (wrappers.length > 1 && wrappers[0].parentNode) {
          wrappers[0].parentNode.removeChild(wrappers[0]);
        }
      }

      var primaryLogoVisible = null;
      themeDom.qsa('img.primary_logo').forEach(function (img) {
        if (themeDom.isVisible(img)) primaryLogoVisible = img;
      });
      if (primaryLogoVisible) {
        var srcHome = themeDom.dataAttr(primaryLogoVisible, 'srcHome') || primaryLogoVisible.getAttribute('data-src-home');
        themeDom.qsa('.feature_image .header .logo img').forEach(function (img) {
          if (srcHome) img.setAttribute('src', srcHome);
        });
      } else {
        var logoImg = themeDom.qs('.logo img');
        var srcNorm = logoImg ? (themeDom.dataAttr(logoImg, 'src') || logoImg.getAttribute('data-src')) : '';
        if (logoImg && srcNorm) logoImg.setAttribute('src', srcNorm);
      }
    } else {
      if (themeDom.qs('#header.mobile_nav-fixed--true')) {
        document.body.classList.add('mobile_nav-fixed--true');
      } else {
        document.body.classList.add('mobile_nav-fixed--false');
      }
    }

    var headerCart = themeDom.qs('#header .cart_container');
    var cartContentSrc = themeDom.qs('.cart_content');
    if (headerCart && cartContentSrc) {
      headerCart.appendChild(cartContentSrc.cloneNode(true));
    }

    if (themeDom.windowWidth() <= 1365) {

      themeDom.qsa('.dropdown_link').forEach(function (a) { a.setAttribute('data-no-instant', 'true'); });

      document.body.addEventListener('click', function (e) {
        var link = e.target.closest('.dropdown_link');
        if (!link) return;
        if (link.classList.contains('mini_cart')) {
          return;
        }

        themeDom.qsa('.nav a').forEach(function (a) { a.classList.remove('active_link'); });

        var hdrVis = themeDom.qs('#header');
        var dd;
        if (hdrVis && themeDom.isVisible(hdrVis)) {
          var drelp = themeDom.dataAttr(link, 'dropdownRel') || link.getAttribute('data-dropdown-rel');
          dd = hdrVis.querySelector('[data-dropdown="' + drelp + '"]');
          themeDom.qsa('.cart_container').forEach(function (c) { c.classList.remove('active_link'); });
        } else {
          if (link.classList.contains('icon-search')) {
            window.location = link.getAttribute('href');
            return;
          }
          var mn = link.closest('.main_nav');
          var drelp2 = themeDom.dataAttr(link, 'dropdownRel') || link.getAttribute('data-dropdown-rel');
          dd = mn ? mn.querySelector('[data-dropdown="' + drelp2 + '"]') : null;
        }

        var ddVis = dd && themeDom.isVisible(dd);
        var ddMissing = !dd || dd.getAttribute('class') == null;
        if (ddVis || ddMissing) {
          if (dd) dd.style.display = 'none';
          document.body.classList.remove('is-active');
        } else {
          themeDom.qsa('.dropdown_container').forEach(function (d) { d.style.display = 'none'; });
          if (!link.classList.contains('cart_container')) {
            themeDom.qsa('.is-absolute').forEach(function (abs) {
              if (abs.parentElement) abs.parentElement.classList.remove('feature_image');
            });
          }
          if (dd) dd.style.display = 'block';
          document.body.classList.add('is-active');
          themeDom.qsa('.mobile_nav').forEach(function (mn0) {
            themeDom.qsa('div', mn0).forEach(function (d0) { d0.classList.remove('open'); });
          });
        }

        if (dd && themeDom.isVisible(dd)) {
          e.stopPropagation();
          e.preventDefault();
        }
      }, { signal: sig });

      document.body.addEventListener('click', function (e) {
        var mn = e.target.closest('.mobile_nav');
        if (!mn) return;
        themeDom.qsa('div', mn).forEach(function (d) { d.classList.toggle('open'); });
      }, { signal: sig });

      var closeDropdown = function () {
        document.body.classList.remove('is-active');
        themeDom.qsa('.dropdown_link').forEach(function (a) { a.classList.remove('active_link'); });
        themeDom.qsa('.dropdown_container').forEach(function (d) { d.style.display = 'none'; });
        themeDom.qsa('.mobile_nav').forEach(function (mn0) {
          themeDom.qsa('div', mn0).forEach(function (d0) { d0.classList.remove('open'); });
        });
      };

      var closeMiniCart = function () {
        document.body.classList.remove('is-active');
        themeDom.qsa('.dropdown_link').forEach(function (a) { a.classList.toggle('active_link'); });
        themeDom.qsa('.cart_container').forEach(function (c) { c.classList.remove('active_link'); });
      };

      var openMiniCart = function (cartContainer) {
        themeDom.qsa('.mobile_nav div').forEach(function (d) { d.classList.remove('open'); });
        themeDom.qsa('.dropdown_link').forEach(function (a) { a.classList.remove('active_link'); });
        if (cartContainer) cartContainer.classList.add('active_link');
      };

      document.documentElement.addEventListener('click', function (event) {
        var t = event.target;
        var ccVis = themeDom.qs('.cart_content');
        if (!t.closest('.cart_container') && ccVis && themeDom.isVisible(ccVis)) {
          closeMiniCart();
        }

        var drp = themeDom.qs('.dropdown');
        if (!t.closest('.dropdown_container') && drp && themeDom.isVisible(drp)) {
          closeDropdown();
        }

      }, { signal: sig });

      if (Shopify.theme_settings.cart_action === 'ajax') {
        themeDom.qsa('.mini_cart').forEach(function (mc) {
          mc.addEventListener('click', function (e) {
            var cart_container = this.parentElement;
            if (cart_container && cart_container.classList.contains('active_link')) {
              closeMiniCart();
            } else if (cart_container) {
              openMiniCart(cart_container);
            }

            if (is_touch_device() || themeDom.windowWidth() <= 798) {
              e.preventDefault();
            }
          }, { signal: sig });
        });

        themeDom.qsa('.cart_content__continue-shopping').forEach(function (el) {
          el.addEventListener('click', function () {
            closeMiniCart();
          }, { signal: sig });
        });
      }

    } else {

      themeDom.qsa('.nav a, .logo a').forEach(function (a) {
        if (a.closest('.cart_content')) return;
        a.addEventListener('mouseenter', function () {
          if (!this.classList.contains('active_link')) {
            themeDom.qsa('.dropdown_container').forEach(function (d) { d.style.display = 'none'; });
            themeDom.qsa('.active_link').forEach(function (x) { x.classList.remove('active_link'); });
            themeDom.qsa('.is-absolute').forEach(function (abs) {
              if (abs.parentElement) abs.parentElement.classList.add('feature_image');
            });
          }
        }, { signal: sig });
      });

      themeDom.qsa('.main_nav, .top_bar, .cart_container').forEach(function (zone) {
        zone.addEventListener('mouseleave', function () {
          themeDom.qsa('.dropdown_container').forEach(function (d) { d.style.display = 'none'; });
          themeDom.qsa('.active_link').forEach(function (x) { x.classList.remove('active_link'); });
          themeDom.qsa('.is-absolute').forEach(function (abs) {
            if (abs.parentElement) abs.parentElement.classList.add('feature_image');
          });
        }, { signal: sig });
      });

      themeDom.qsa('.dropdown_link, .dropdown_link--vertical').forEach(function (a) {
        a.setAttribute('data-click-count', '0');
      });

      themeDom.qsa('.dropdown_link').forEach(function (dl) {
        ['mouseover', 'touchstart'].forEach(function (evName) {
          dl.addEventListener(evName, function (e) {
            var mn = this.closest('.main_nav');
            var drelp = themeDom.dataAttr(this, 'dropdownRel') || this.getAttribute('data-dropdown-rel');
            var dropdown = mn ? mn.querySelector('[data-dropdown="' + drelp + '"]') : null;
            var clickCount = parseInt(this.getAttribute('data-click-count') || '0', 10);

            themeDom.qsa('.active_link').forEach(function (x) { x.classList.remove('active_link'); });

            if (!this.classList.contains('active_link')) {
              if (dropdown) dropdown.style.display = '';

              if (this.classList.contains('mini_cart')) {
                var pc = this.closest('.cart_container');
                if (pc) pc.classList.add('active_link');
              } else {
                this.classList.add('active_link');
                themeDom.qsa('.is-absolute').forEach(function (abs) {
                  if (abs.parentElement) abs.parentElement.classList.remove('feature_image');
                });
              }
            }

            if (is_touch_device()) {
              themeDom.qsa('.dropdown_link').forEach(function (o) {
                if (o !== dl) o.setAttribute('data-click-count', '0');
              });
              themeDom.qsa('.dropdown_link').forEach(function (o) {
                o.setAttribute('data-no-instant', 'true');
              });

              if (e.type === 'touchstart') {
                if (this.classList.contains('mini_cart')) {
                  return;
                }
                clickCount++;
                this.setAttribute('data-click-count', String(clickCount));

                if (clickCount < 2) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }
            }

          }, { signal: sig });
        });
      });

      if (themeDom.qsa('.dropdown_link--vertical').length) {
        themeDom.qsa('.dropdown_link--vertical').forEach(function (dv) {
          dv.addEventListener('mouseover', function () {
            themeDom.qsa('.active_link').forEach(function (x) { x.classList.remove('active_link'); });
            if (!this.classList.contains('active_link')) {
              Array.prototype.forEach.call(this.children, function (ch) {
                if (ch.tagName === 'A') ch.classList.add('active_link');
              });
              themeDom.qsa('.is-absolute').forEach(function (abs) {
                if (abs.parentElement) abs.parentElement.classList.remove('feature_image');
              });
            }
          }, { signal: sig });
        });

        if (is_touch_device()) {
          themeDom.qsa('.dropdown_link--vertical').forEach(function (dv) {
            dv.addEventListener('touchstart', function (e) {
              var mn = this.closest('.main_nav');
              var drelp = themeDom.dataAttr(this, 'dropdownRel') || this.getAttribute('data-dropdown-rel');
              var dropdownPanel = mn ? mn.querySelector('[data-dropdown="' + drelp + '"]') : null;
              var dropdownVertical = this.nextElementSibling;
              while (dropdownVertical && !dropdownVertical.classList.contains('vertical-menu_submenu')) {
                dropdownVertical = dropdownVertical.nextElementSibling;
              }
              var clickCount = parseInt(this.getAttribute('data-click-count') || '0', 10);

              themeDom.qsa('.dropdown_link--vertical').forEach(function (o) {
                if (o !== dv) o.setAttribute('data-click-count', '0');
              });
              themeDom.qsa('.dropdown_link--vertical').forEach(function (o) {
                o.setAttribute('data-no-instant', 'true');
              });
              themeDom.qsa('.dropdown_container').forEach(function (d) { d.style.display = 'none'; });

              if (dropdownPanel) dropdownPanel.style.display = '';
              themeDom.qsa('.vertical-menu_submenu').forEach(function (v) { v.classList.remove('is-visible'); });
              if (dropdownVertical) dropdownVertical.classList.add('is-visible');

              if (e.type === 'touchstart') {
                clickCount++;
                this.setAttribute('data-click-count', String(clickCount));

                if (clickCount < 2) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }
            }, { signal: sig });
          });
        }
      }

    }

  },
  removeDataAttributes: function (target) {
    themeDom.qsa(target).forEach(function (el) {
      var dataAttrsToDelete = [];
      var attrs = el.attributes;
      for (var i = 0; i < attrs.length; i++) {
        if (attrs[i].name.substring(0, 5) === 'data-') {
          dataAttrsToDelete.push(attrs[i].name);
        }
      }
      dataAttrsToDelete.forEach(function (attrName) {
        el.removeAttribute(attrName);
      });
    });
  },
  unload: function () {
    if (header._headerAbort) header._headerAbort.abort();
    header._headerAbort = null;
  }
}


function sprRefreshBadges() {
  if (typeof SPR === 'undefined') return;
  function run() {
    if (typeof SPR.registerCallbacks === 'function') SPR.registerCallbacks();
    if (typeof SPR.initRatingHandler === 'function') SPR.initRatingHandler();
    if (typeof SPR.initDomEls === 'function') SPR.initDomEls();
    if (typeof SPR.loadProducts === 'function') SPR.loadProducts();
    if (typeof SPR.loadBadges === 'function') SPR.loadBadges();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
}



var enableLoadMoreProducts = function () {
  themeDom.delegate(document.body, 'click', '.js-load-more a', function (e) {
    enableCollectionLoadMoreAjax();
    e.stopPropagation();
    e.preventDefault();
    return false;
  });
}

var enableCollectionLoadMoreAjax = function () {
  var matrixEl = themeDom.qs('.collection-matrix');
  if (!matrixEl || typeof Waypoint === 'undefined') return;

  var itemsSelector = '.collection-matrix';
  var moreSelector = '.load-more__btn';
  var loadingClass = 'loading-in-progress';

  if (matrixEl._collectionLoadMoreWp) {
    matrixEl._collectionLoadMoreWp.destroy();
    matrixEl._collectionLoadMoreWp = null;
  }

  function onBeforePageLoad() {
    themeDom.qsa('.js-load-more').forEach(function (el) {
      themeDom.hide(el);
    });
  }

  function onAfterPageLoad() {
    if (Shopify.theme_settings.enable_shopify_collection_badges) {
      sprRefreshBadges();
    }
  }

  function attachWaypoint() {
    var moreLink = matrixEl.querySelector(moreSelector);
    if (!moreLink || !moreLink.getAttribute('href')) return;

    var wp = new Waypoint({
      element: matrixEl,
      offset: 'bottom-in-view',
      handler: function () {
        var selfWp = this;
        var more = matrixEl.querySelector(moreSelector);
        if (!more || !more.getAttribute('href')) return;

        onBeforePageLoad();
        matrixEl._collectionLoadMoreWp = null;
        selfWp.destroy();
        matrixEl.classList.add(loadingClass);

        var url = more.getAttribute('href');
        themeDom.ajax({
          type: 'GET',
          url: url,
          dataType: 'html',
          success: function (data) {
            var doc = themeDom.parseHtmlDoc(data);
            var list = doc.querySelectorAll(itemsSelector);
            var i;
            if (!list.length && doc.body) {
              for (i = 0; i < doc.body.children.length; i++) {
                var ch = doc.body.children[i];
                if (ch.matches && ch.matches(itemsSelector)) {
                  matrixEl.appendChild(document.importNode(ch, true));
                }
              }
            } else {
              for (i = 0; i < list.length; i++) {
                matrixEl.appendChild(document.importNode(list[i], true));
              }
            }

            matrixEl.classList.remove(loadingClass);

            var newBtn = doc.querySelector(moreSelector);
            var oldBtn = matrixEl.querySelector(moreSelector);
            if (newBtn && oldBtn && oldBtn.parentNode) {
              oldBtn.parentNode.replaceChild(document.importNode(newBtn, true), oldBtn);
            } else if (oldBtn) {
              var wrap = oldBtn.closest ? oldBtn.closest('.js-load-more') : null;
              if (wrap) wrap.remove();
              else oldBtn.remove();
            }

            onAfterPageLoad();
            attachWaypoint();
          },
          error: function () {
            matrixEl.classList.remove(loadingClass);
          }
        });
      }
    });
    matrixEl._collectionLoadMoreWp = wp;
  }

  attachWaypoint();
}



Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

var quickFilter = {
  init: function () {
    var selectedOptions = [],
      query = '',
      currentTags = '',
      url1 = themeDom.urlSeg('1') ? '/' + themeDom.urlSeg('1') + '/' : '',
      url2 = themeDom.urlSeg('2') ? themeDom.urlSeg('2') + '/' : '',
      path = url1 + url2;

    var sortEl = themeDom.qs('#sort-by');
    if (sortEl) {
      query = sortEl.value;
    } else {
      query = typeof url === 'function' ? url('?sort_by') : '';
    }

    var tagFilter = themeDom.qs('#tag_filter');
    if (tagFilter) {
      var defCol = themeDom.dataAttr(tagFilter, 'defaultCollection') || tagFilter.getAttribute('data-default-collection');
      if (defCol != tagFilter.value) {
        var urlTag = tagFilter.value.substr(tagFilter.value.lastIndexOf('/') + 1);

        if (urlTag != 'all') {
          if (selectedOptions.indexOf(urlTag) === -1) {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    themeDom.qsa('[data-option-filter] input:checked').forEach(function (inp) {
      selectedOptions.push(inp.value);
    });

    selectedOptions.forEach(function (value, i) {
      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }
    });

    Shopify.queryParams.sort_by = query;
    query = '?' + themeDom.param(Shopify.queryParams);

    quickFilter.processUrl(path, currentTags, query);
  },
  updateView: function (filterURL) {

    var matrix = themeDom.qs('.collection-matrix');
    if (matrix) {
      matrix.classList.add('fadeOut', 'animated', 'loading-in-progress', 'filter-loading');
    }
    if (typeof Waypoint !== 'undefined' && Waypoint.destroyAll) Waypoint.destroyAll();

    themeDom.ajax({
      type: 'GET',
      url: filterURL,
      dataType: 'html',
      success: function (data) {
        var doc = themeDom.parseHtmlDoc(data);
        themeDom.qsa('.collection-matrix').forEach(function (m) {
          m.classList.remove('loading-in-progress', 'filter-loading');
        });

        var fb = doc.querySelector('.breadcrumb_text');
        var bt = themeDom.qs('.breadcrumb_text');
        if (fb && bt) bt.innerHTML = fb.innerHTML;

        var pag = doc.querySelector('.paginate');
        var pagEl = themeDom.qs('.paginate');
        if (pag && pagEl) pagEl.innerHTML = pag.innerHTML;

        var side = doc.querySelector('.sidebar');
        var sideEl = themeDom.qs('.sidebar');
        if (side && sideEl) sideEl.innerHTML = side.innerHTML;

        var newMatrix = doc.querySelector('.collection-matrix');
        var anchor = themeDom.qs('.load-more__icon');
        var oldMatrix = themeDom.qs('.collection-matrix');
        if (oldMatrix && oldMatrix.parentNode && newMatrix && anchor && anchor.parentNode) {
          oldMatrix.parentNode.removeChild(oldMatrix);
          anchor.parentNode.insertBefore(document.importNode(newMatrix, true), anchor);
        }

        window.history && window.history.pushState && window.history.pushState('', '', filterURL);

        if (themeDom.qs('.sidebar__collection-filter')) {
          collectionSidebarFilter.init();
        }

        if (Shopify.theme_settings.pagination_type === 'load_more') {
          enableCollectionLoadMoreAjax();
        }

        if (Shopify.theme_settings.enable_shopify_collection_badges) {
          sprRefreshBadges();
        }
      },
      error: function (x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      }
    });
  },
  processUrl: function (path, tags, query) {

    var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';

    urlString = path + tags + query;

    quickFilter.updateView(urlString);

  }
};

(function () {
  var sortByEl = themeDom.qs('#sort-by');
  if (sortByEl) {
    var ds = themeDom.dataAttr(sortByEl, 'defaultSort') || sortByEl.getAttribute('data-default-sort');
    if (ds != null) sortByEl.value = ds;
  }
})();

themeDom.delegate(document.body, 'change', '#tag_filter, #sort-by', function () {
  quickFilter.init();
});

themeDom.delegate(document.body, 'change', '#blog_filter', function () {
  window.location = this.value;
});

document.addEventListener('focus', function (event) {
  var t = event.target;
  if (!t || !t.matches || !t.matches('input, select, textarea')) return;
  var mv = themeDom.qs('meta[name="viewport"]');
  if (mv) mv.setAttribute('content', 'width=device-width,initial-scale=1,maximum-scale=1');
}, true);
document.addEventListener('blur', function (event) {
  var t = event.target;
  if (!t || !t.matches || !t.matches('input, select, textarea')) return;
  var mv = themeDom.qs('meta[name="viewport"]');
  if (mv) mv.setAttribute('content', 'width=device-width,initial-scale=1,maximum-scale=10');
}, true);



var collectionSidebarFilter = {
  init: function () {

    themeDom.qsa('.filter-active-tag input:checked').forEach(function (inp) {
      var fat = inp.closest('.filter-active-tag');
      if (!fat || !fat.parentElement) return;
      Array.prototype.forEach.call(fat.parentElement.children, function (sib) {
        if (sib !== fat && sib.classList.contains('filter-all-tags')) {
          sib.style.display = 'none';
        }
      });
    });
    themeDom.qsa('.toggle-all--true .toggle_list .filter-active-tag input:checked').forEach(function (inp) {
      var ul = inp.closest('ul.toggle_list');
      if (ul && ul.previousElementSibling) ul.previousElementSibling.click();
    });

    if (themeDom.urlSeg('2') === 'types' || themeDom.urlSeg('2') === 'vendors') {
      themeDom.qsa('.sidebar__collection-filter').forEach(function (el) { el.remove(); });
    }

    themeDom.qsa('.sidebar-block:empty').forEach(function (sb) {
      var prev = sb.previousElementSibling;
      if (prev) prev.style.borderBottom = 'none';
    });

  },
  clearAllFilters: function () {
    themeDom.qsa('[data-option-filter] input').forEach(function (inp) {
      inp.checked = false;
      themeDom.trigger(inp, 'change');
    });
  },
  clearSelectedFilter: function (optionFilter) {
    var root = themeDom.el(optionFilter);
    if (!root) return;
    themeDom.qsa('[data-option-filter] input', root).forEach(function (inp) {
      inp.checked = false;
      themeDom.trigger(inp, 'change');
    });
  }
}



var collectionSidebarFilterMobile = {
  init: function () {

    themeDom.qsa('.filter-active-tag-mobile input:checked').forEach(function (inp) {
      var fat = inp.closest('.filter-active-tag-mobile');
      if (!fat || !fat.parentElement) return;
      Array.prototype.forEach.call(fat.parentElement.children, function (sib) {
        if (sib !== fat && sib.classList.contains('filter-all-tags-mobile')) {
          sib.style.display = 'none';
        }
      });
    });
    themeDom.qsa('.toggle-all--true .toggle_list .filter-active-tag-mobile input:checked').forEach(function (inp) {
      var ul = inp.closest('ul.toggle_list');
      if (ul && ul.previousElementSibling) ul.previousElementSibling.click();
    });

    if (themeDom.urlSeg('2') === 'types' || themeDom.urlSeg('2') === 'vendors') {
      themeDom.qsa('.sidebar__collection-filter-mobile').forEach(function (el) { el.remove(); });
    }

    themeDom.qsa('.sidebar-block:empty').forEach(function (sb) {
      var prev = sb.previousElementSibling;
      if (prev) prev.style.borderBottom = 'none';
    });

  },
  clearAllFiltersMobile: function () {
    themeDom.qsa('[data-option-filter-mobile] input').forEach(function (inp) {
      inp.checked = false;
      themeDom.trigger(inp, 'change');
    });
  },
  clearSelectedFilterMobile: function (optionFilterMobile) {
    var root = themeDom.el(optionFilterMobile);
    if (!root) return;
    themeDom.qsa('[data-option-filter-mobile] input', root).forEach(function (inp) {
      inp.checked = false;
      themeDom.trigger(inp, 'change');
    });
  }
}

themeDom.delegate(document.body, 'change', '[data-option-filter] input', function () {
  quickFilter.init();
});

themeDom.delegate(document.body, 'click', '[data-reset-filters]', function () {
  collectionSidebarFilter.clearAllFilters();
  collectionSidebarFilterMobile.clearAllFiltersMobile();
});

themeDom.delegate(document.body, 'click', '[data-clear-filter]', function () {
  var selectedOption = themeDom.closestParent(this, '.filter-active-tag');
  if (selectedOption) collectionSidebarFilter.clearSelectedFilter(selectedOption);
});

themeDom.delegate(document.body, 'change', '[data-option-filter-mobile] input', function () {
  quickFilter.init();
});

themeDom.delegate(document.body, 'click', '[data-clear-filter-mobile]', function () {
  var selectedOptionMobile = themeDom.closestParent(this, '.filter-active-tag-mobile');
  if (selectedOptionMobile) collectionSidebarFilterMobile.clearSelectedFilterMobile(selectedOptionMobile);
});



var faqAccordion = {
  // Same motion as product `collapsible-tab` / `animatedDetails`: `themeDom.slideToggle` on `.details-content`
  // (ACCORDION_SLIDE_MS + cubic-bezier in slideToggle), with copy in `.collapsible-tab__text` for typography.

  ensurePanelInner: function (dd) {
    if (!dd || dd.tagName !== 'DD') return;
    var wrapper = dd.querySelector(':scope > .details-content');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'details-content';
      while (dd.firstChild) {
        wrapper.appendChild(dd.firstChild);
      }
      dd.appendChild(wrapper);
    }
    var firstInner = wrapper.firstElementChild;
    if (!firstInner || !firstInner.classList || !firstInner.classList.contains('collapsible-tab__text')) {
      var textWrap = document.createElement('div');
      textWrap.className = 'collapsible-tab__text';
      while (wrapper.firstChild) {
        textWrap.appendChild(wrapper.firstChild);
      }
      wrapper.appendChild(textWrap);
    }
  },

  init: function () {
    if (!faqAccordion._delegateInstalled) {
      faqAccordion._delegateInstalled = true;
      themeDom.delegate(document.body, 'click', '.faqAccordion > dt > button', function (e) {
        e.preventDefault();
        var btn = this;
        var dd = btn.parentElement && btn.parentElement.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        faqAccordion.ensurePanelInner(dd);
        var wrapper = dd.querySelector(':scope > .details-content');
        if (!wrapper) return;

        var opening = !btn.classList.contains('active');
        btn.classList.toggle('active');

        if (opening) {
          btn.setAttribute('aria-expanded', 'true');
          dd.setAttribute('aria-hidden', 'false');
          wrapper.style.display = 'none';
          themeDom.slideToggle(wrapper, null, ACCORDION_SLIDE_MS);
        } else {
          btn.setAttribute('aria-expanded', 'false');
          themeDom.slideToggle(wrapper, function () {
            dd.setAttribute('aria-hidden', 'true');
          }, ACCORDION_SLIDE_MS);
        }
      });
    }

    var openFirst = [];
    themeDom.qsa('.faqAccordion > dt > button').forEach(function (btn) {
      if (btn.getAttribute('aria-expanded') === 'true' || btn.classList.contains('active')) {
        openFirst.push(btn);
      }
    });

    themeDom.qsa('.faqAccordion > dd').forEach(function (dd) {
      dd.removeAttribute('style');
      faqAccordion.ensurePanelInner(dd);
      var w = dd.querySelector(':scope > .details-content');
      if (w) {
        w.removeAttribute('style');
        w.style.display = 'none';
      }
      dd.setAttribute('aria-hidden', 'true');
    });

    themeDom.qsa('.faqAccordion > dt > button').forEach(function (btn) {
      btn.classList.remove('active');
      btn.setAttribute('aria-expanded', 'false');
    });

    openFirst.forEach(function (btn) {
      btn.classList.add('active');
      btn.setAttribute('aria-expanded', 'true');
      var dd = btn.parentElement && btn.parentElement.nextElementSibling;
      if (dd && dd.tagName === 'DD') {
        faqAccordion.ensurePanelInner(dd);
        var w = dd.querySelector(':scope > .details-content');
        if (w) {
          w.style.display = 'block';
          w.style.maxHeight = '';
          w.style.transition = '';
          w.style.overflow = '';
        }
        dd.setAttribute('aria-hidden', 'false');
      }
    });
  }
}

// Slide-animate native <details>/<summary> via themeDom.slideToggle so the
// motion matches the footer (400ms cubic-bezier). Wraps non-summary children
// in a .details-content div so a single element drives the animation.
var animatedDetails = {
  init: function (selector) {
    themeDom.qsa(selector).forEach(function (d) { animatedDetails.attach(d); });
  },
  attach: function (details) {
    if (!details || details.tagName !== 'DETAILS' || details._slideAttached) return;
    details._slideAttached = true;
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;

    var wrapper = details.querySelector(':scope > .details-content');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'details-content';
      var node = summary.nextSibling;
      while (node) {
        var next = node.nextSibling;
        wrapper.appendChild(node);
        node = next;
      }
      details.appendChild(wrapper);
    }
    if (!details.hasAttribute('open')) wrapper.style.display = 'none';

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.hasAttribute('open')) {
        themeDom.slideToggle(wrapper, function () {
          details.removeAttribute('open');
        }, ACCORDION_SLIDE_MS);
      } else {
        details.setAttribute('open', '');
        wrapper.style.display = 'none';
        themeDom.slideToggle(wrapper, null, ACCORDION_SLIDE_MS);
      }
    });
  }
};



var arrowSize = Shopify.theme_settings.slideshow_arrow_shape;


var lightboxGallery = {
  init: function () {
    if (!themeDom.qs('.lightbox img')) return;
    var lightboxLinks = themeDom.qsa('a.lightbox');
    var groups = [];
    lightboxLinks.forEach(function (a) {
      var r = a.getAttribute('rel');
      if (r != null && groups.indexOf(r) === -1) groups.push(r);
    });

    groups.forEach(function (value, index) {
      var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(String(value)) : String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      themeDom.qsa('a.lightbox[rel="' + esc + '"]').forEach(function (a) {
        a.setAttribute('data-remodal-target', 'lightbox-id-' + index);
      });

      var lightboxModal = [
        '<div class="remodal remodal-lightbox js-remodal-lightbox js-lightbox-' + index + '" data-rel="' + String(value).replace(/"/g, '&quot;') + '" data-remodal-id="lightbox-id-' + index + '" data-remodal-options="hashTracking: false">',
        '<a data-remodal-action="close" class="remodal-close"></a>',
        '<div class="lightbox-gallery"></div>',
        '</div>'
      ].join('');

      document.body.insertAdjacentHTML('beforeend', lightboxModal);

      var imgIdx = 0;
      lightboxLinks.forEach(function (a) {
        if (a.getAttribute('rel') !== value) return;
        a.setAttribute('data-image-id', String(imgIdx++));
        a.setAttribute('data-no-instant', '');
      });
    });
  }
}

var utils = {
  createAccordion: function (container, tab, content) {
    var cont = themeDom.qs(container);
    if (!cont) return;
    var specificTab = container + ' ' + tab;
    if (container.indexOf('.accordion-tabs') >= 0) {
      var tabs = themeDom.qsa(tab, cont);
      var contents = themeDom.qsa(content, cont);
      themeDom.empty(cont);
      for (var i = 0; i < tabs.length; i++) {
        cont.appendChild(tabs[i]);
        if (contents[i]) cont.appendChild(contents[i]);
      }
      themeDom.qsa(content, cont).forEach(function (c) { c.classList.remove('active'); });
      var activeEl = cont.querySelector('.active');
      if (activeEl && activeEl.nextElementSibling) themeDom.slideToggle(activeEl.nextElementSibling, undefined, ACCORDION_SLIDE_MS);
      tab = '> a';
      specificTab = container + ' > a';
    }
    Array.prototype.filter.call(cont.children, function (c) { return c.tagName === 'A'; }).forEach(function (a) {
      var tabValue = a.getAttribute('href');
      if (tabValue) {
        a.setAttribute('data-tab-value', tabValue);
        a.removeAttribute('href');
      }
    });
    var tabSel = tab.indexOf('>') === 0 ? ':scope ' + tab : tab;
    var activeTab = cont.querySelector(tabSel + '.active') || cont.querySelector(tab + '.active');
    if (activeTab && activeTab.nextElementSibling) themeDom.slideToggle(activeTab.nextElementSibling, undefined, ACCORDION_SLIDE_MS);
    themeDom.delegate(document.body, 'click', specificTab, function (e) {
      e.preventDefault();
      this.classList.toggle('active');
      var nx = this.nextElementSibling;
      if (nx) themeDom.slideToggle(nx, undefined, ACCORDION_SLIDE_MS);
    });
  },
  mobileAccordion: function (container, tab, content) {
    var cont = themeDom.qs(container);
    if (!cont) return;
    var first = cont.querySelector(tab + '.active');
    if (first && first.nextElementSibling) themeDom.slideToggle(first.nextElementSibling, undefined, ACCORDION_SLIDE_MS);

    themeDom.delegate(document.body, 'click', tab, function (e) {
      e.preventDefault();
      this.classList.toggle('active');
      if (this.nextElementSibling) themeDom.slideToggle(this.nextElementSibling, undefined, ACCORDION_SLIDE_MS);
    });
  },
  mobileParentActiveAccordion: function (container, tab, content) {
    var cont = themeDom.qs(container);
    if (!cont) return;
    var first = cont.querySelector(tab + '.active');
    if (first && first.parentElement && first.parentElement.nextElementSibling) {
      themeDom.slideToggle(first.parentElement.nextElementSibling, undefined, ACCORDION_SLIDE_MS);
    }

    themeDom.delegate(document.body, 'click', tab, function (e) {
      e.preventDefault();
      this.classList.toggle('active');
      var par = this.parentElement;
      if (par && par.nextElementSibling) themeDom.slideToggle(par.nextElementSibling, undefined, ACCORDION_SLIDE_MS);
    });
  },
  initializeTabs: function () {
    themeDom.qsa('ul.tabs > li > a').forEach(function (a) {
      a.setAttribute('data-no-instant', 'true');
    });
    themeDom.delegate(document.body, 'click', 'ul.tabs > li > a', function (e) {
      e.preventDefault();
      var contentLocation = this.getAttribute('href');
      if (!contentLocation || contentLocation.charAt(0) !== '#') return;
      themeDom.qsa('ul.tabs > li > a.active').forEach(function (x) { x.classList.remove('active'); });
      this.classList.add('active');
      var tabsUl = themeDom.closestParent(this, 'ul.tabs');
      if (!tabsUl || !tabsUl.nextElementSibling) return;
      var panels = tabsUl.nextElementSibling;
      var target = panels.querySelector(contentLocation);
      Array.prototype.forEach.call(panels.children, function (panel) {
        if (panel === target) {
          panel.style.display = 'block';
          panel.classList.add('active');
        } else {
          panel.style.display = 'none';
          panel.classList.remove('active');
        }
      });
    });
  },
  pageBannerCheck: function () {
    var pageBanner = themeDom.qs('.page_banner');
    var headerSolid = themeDom.qs('.header.header-background--solid');
    if (!pageBanner || headerSolid) {
      themeDom.qsa('.feature_image').forEach(function (el) { el.classList.remove('feature_image'); });
      themeDom.qsa('.header.is-absolute').forEach(function (el) { el.classList.remove('is-absolute'); });
      themeDom.qsa('.secondary_logo--true .secondary_logo').forEach(function (el) { themeDom.hide(el); });
      themeDom.qsa('.secondary_logo--true .primary_logo').forEach(function (el) { themeDom.show(el); });
    } else {
      var hdr = themeDom.qs('.header');
      if (hdr && hdr.parentElement) hdr.parentElement.classList.add('feature_image');
      themeDom.qsa('.header').forEach(function (h) { h.classList.add('is-absolute'); });
      var featHdr = themeDom.qs('header.feature_image');
      if (featHdr && featHdr.classList.contains('secondary_logo--true')) {
        themeDom.qsa('.secondary_logo--true .secondary_logo').forEach(function (el) { themeDom.show(el); });
        themeDom.qsa('.secondary_logo--true .primary_logo').forEach(function (el) { themeDom.hide(el); });
      }
    }

    var indexFirst = themeDom.qs('.index-sections');
    var indexFirstChild = indexFirst && indexFirst.children.length ? indexFirst.children[0] : null;
    if (indexFirstChild && indexFirstChild.classList.contains('under-menu')) {
      if (!themeDom.qs('.header.header-background--solid')) {
        themeDom.qsa('.index .header').forEach(function (h) {
          if (h.parentElement) h.parentElement.classList.add('feature_image');
          h.classList.add('is-absolute');
        });
      }
      var fh = themeDom.qs('header.feature_image');
      if (fh && fh.classList.contains('secondary_logo--true')) {
        themeDom.qsa('.secondary_logo--true .secondary_logo').forEach(function (el) { themeDom.show(el); });
        themeDom.qsa('.secondary_logo--true .primary_logo').forEach(function (el) { themeDom.hide(el); });
      }
    } else {
      themeDom.qsa('.index .feature_image').forEach(function (el) { el.classList.remove('feature_image'); });
      themeDom.qsa('.index .header.is-absolute').forEach(function (el) { el.classList.remove('is-absolute'); });
      var fh2 = themeDom.qs('header.feature_image');
      if (!fh2 || !fh2.classList.contains('secondary_logo--true')) {
        themeDom.qsa('.secondary_logo--true .secondary_logo').forEach(function (el) { themeDom.hide(el); });
        themeDom.qsa('.secondary_logo--true .primary_logo').forEach(function (el) { themeDom.show(el); });
      }
    }

    var detailFirst = themeDom.qs('.detail-sections');
    var detailChild = detailFirst && detailFirst.children.length ? detailFirst.children[0] : null;
    if (detailChild && detailChild.classList.contains('under-menu')) {
      if (!themeDom.qs('.header.header-background--solid')) {
        themeDom.qsa('[class^="page-details"] .header').forEach(function (h) {
          if (h.parentElement) h.parentElement.classList.add('feature_image');
          h.classList.add('is-absolute');
        });
      }
      var fh3 = themeDom.qs('header.feature_image');
      if (fh3 && fh3.classList.contains('secondary_logo--true')) {
        themeDom.qsa('.secondary_logo--true .secondary_logo').forEach(function (el) { themeDom.show(el); });
        themeDom.qsa('.secondary_logo--true .primary_logo').forEach(function (el) { themeDom.hide(el); });
      }
    } else {
      themeDom.qsa('[class^="page-details"] .feature_image').forEach(function (el) { el.classList.remove('feature_image'); });
      themeDom.qsa('[class^="page-details"] .header.is-absolute').forEach(function (el) { el.classList.remove('is-absolute'); });
      var fh4 = themeDom.qs('header.feature_image');
      if (!fh4 || !fh4.classList.contains('secondary_logo--true')) {
        themeDom.qsa('.secondary_logo--true .secondary_logo').forEach(function (el) { themeDom.hide(el); });
        themeDom.qsa('.secondary_logo--true .primary_logo').forEach(function (el) { themeDom.show(el); });
      }
    }
  },
  resizeActionButtons: function () {
    themeDom.qsa('.js-caption').forEach(function (cap) {
      if (!themeDom.isVisible(cap)) return;
      var buttonWidth = 0;
      themeDom.qsa('.action_button', cap).forEach(function (btn) {
        var w = btn.offsetWidth;
        if (w > buttonWidth) buttonWidth = w;
      });
      themeDom.qsa('.action_button', cap).forEach(function (btn) {
        btn.style.width = buttonWidth ? buttonWidth + 'px' : '';
      });
    });
  }
}

var sliderBlock = {
  select: function (blockId, parentSection) {
    var root = themeDom.el(parentSection);
    if (!root) return;
    var blocks = themeDom.qsa('.gallery-cell', root);
    var blockIdsArray = blocks.map(function (b) {
      return String(themeDom.dataAttr(b, 'blockId') || b.getAttribute('data-block-id') || '');
    });
    var slider = root.querySelector('.js-homepage-slideshow');
    var flkty = themeDom.flickityData(slider);
    if (!slider || !flkty) return;
    if (flkty.pausePlayer) flkty.pausePlayer();

    for (var i = 0; i < blockIdsArray.length; i++) {
      if (blockIdsArray[i] === String(blockId)) {
        if (i !== flkty.selectedIndex) {
          flkty.select(parseInt(i, 10), false, true);
        }
        break;
      }
    }
  },
  deselect: function (parentSection) {
    var root = themeDom.el(parentSection);
    if (!root) return;
    var slider = root.querySelector('.js-homepage-slideshow') || root.querySelector('.flexslider');
    var flkty = themeDom.flickityData(slider);
    if (flkty && flkty.unpausePlayer) flkty.unpausePlayer();
  }
}

function themeBootstrap() {

  var currentSlide = 0;

  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    var that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', function () {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  header.init();
  utils.pageBannerCheck();
  slideshow.init();
  testimonial.init();
  gallery.init();
  themeRemodal.init();
  videoSection.init();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  collectionSidebarFilterMobile.init();
  cart.init();

  productPage.initializeQuantityBox();
  productPage.init();
  productPage.relatedProducts();

  recentlyViewed.init();

  themeDom.delegate(document.body, 'click', '.lightbox', function () {
    var sid = themeDom.dataAttr(this, 'imageId');
    currentSlide = sid != null ? parseInt(sid, 10) || 0 : 0;
  });

  themeDom.delegate(document.body, 'opened', '.js-remodal-lightbox', function () {

    var currentLightbox = this;
    var currentLightboxGallery = currentLightbox.querySelector('.lightbox-gallery');
    var currentLightboxImages = currentLightbox.querySelectorAll('.lightbox-image');
    var pg = themeDom.qs('.product_gallery');
    var activate_zoom = pg ? themeDom.dataAttr(pg, 'zoom') : null;
    var arrowShow = currentLightboxImages.length !== 1;
    var group = themeDom.dataAttr(currentLightbox, 'rel') || currentLightbox.getAttribute('data-rel');
    var draggable = true;

    if (activate_zoom != null) currentLightbox.setAttribute('data-zoom', activate_zoom);

    if (activate_zoom && themeDom.windowWidth() <= 798) {
      draggable = false;
    } else {
      draggable = currentLightboxImages.length !== 1;
    }

    if (currentLightboxGallery && !currentLightboxGallery.classList.contains('flickity-enabled')) {
      themeDom.flickityCreate(currentLightboxGallery, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        lazyLoad: 2,
        pageDots: usePageDots,
        draggable: draggable,
        prevNextButtons: arrowShow,
        selectedAttraction: 0.01,
        friction: 0.15,
        arrowShape: arrowSize
      });
    }

    var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(String(group)) : String(group).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    var groupImages = themeDom.qsa('a.lightbox[rel="' + esc + '"]');

    groupImages.forEach(function (link) {
      var imagePath = link.getAttribute('href');
      var cell = document.createElement('div');
      cell.className = 'gallery-cell';
      var img = document.createElement('img');
      img.src = imagePath;
      img.className = 'lightbox-image';
      cell.appendChild(img);

      var cellCount = currentLightboxGallery ? currentLightboxGallery.querySelectorAll('.gallery-cell').length : 0;
      if (groupImages.length > cellCount) {
        var fl = themeDom.flickityData(currentLightboxGallery);
        if (fl) fl.append(cell);
      }
      var flkty = themeDom.flickityData(currentLightboxGallery);
      if (flkty) flkty.select(currentSlide, false, true);
      themeDom.qsa('.lightbox-image', currentLightbox).forEach(function (im) {
        im.style.opacity = '1';
      });
    });

    if (activate_zoom && themeDom.windowWidth() <= 798) {
      imageFunctions.zoom('.js-remodal-lightbox', true, 1.8);
    }

  });

  themeDom.delegate(document.body, 'closed', '.js-remodal-lightbox', function () {
    themeDom.qsa('.lightbox-image', this).forEach(function (im) {
      im.style.opacity = '0';
    });
  });

  if (Shopify.theme_settings.newsletter_popup_feature) {
    newsletter_popup.init();
  }

  productpagenote_popup.init();

  if (window.location.pathname.indexOf('/comments') !== -1) {
    var ncEl = themeDom.qs('#new-comment');
    if (ncEl) {
      var y = ncEl.getBoundingClientRect().top + themeDom.scrollTop() - 140;
      themeDom.scrollAnimateY(y, 600);
    }
  }

  themeDom.delegate(document.body, 'mouseenter', '.icon-search', function () {
    var st = themeDom.qs('.search-terms');
    if (st) st.focus();
  });

  themeDom.delegate(document.body, 'click', '.search-submit', function () {
    var p = this.parentElement;
    if (p && p.tagName === 'FORM') p.submit();
  });

  if (themeDom.windowWidth() > 798 && typeof Waypoint !== 'undefined') {
    function waypointAnimate(sel, classNames) {
      themeDom.qsa(sel).forEach(function (el) {
        new Waypoint({
          element: el,
          handler: function () {
            var node = this.element;
            classNames.split(/\s+/).forEach(function (c) { if (c) node.classList.add(c); });
          },
          offset: '70%'
        });
      });
    }
    waypointAnimate('.animate_right', 'animated fadeInRight');
    waypointAnimate('.animate_left', 'animated fadeInLeft');
    waypointAnimate('.animate_up', 'animated fadeInUp');
    waypointAnimate('.animate_down', 'animated fadeInDown');
  }

  themeDom.flexsliderUnwrapLists();
  themeDom.qsa('.slider, .flexslider').forEach(function (el) {
    if (!themeDom.flickityData(el)) {
      themeDom.flickityCreate(el, {
        pageDots: usePageDots,
        imagesLoaded: true,
        lazyLoad: 2
      });
    }
  });

  // sidebar accordions are now native <details>/<summary> — no JS needed
  utils.createAccordion('.footer_menu', 'h6', 'ul');
  utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();
  faqAccordion.init();

  // Slide-animate these <details> blocks to match footer toggle motion.
  animatedDetails.init('.collapsible-tab');
  animatedDetails.init('.sidebar__collection-filter > details');

  window.addEventListener('resize', function () {
    utils.resizeActionButtons();
  });


  themeDom.delegate(document.body, 'click', '.menu-toggle', function () {
    var ul = this.nextElementSibling;
    if (ul && ul.tagName === 'UL') themeDom.slideToggle(ul);
    this.classList.toggle('active');
    var exp = this.getAttribute('aria-expanded');
    this.setAttribute('aria-expanded', exp === 'true' ? 'false' : 'true');
  });

  if (themeDom.qs('.shopify-section.page-details-section')) {

  } else if (document.body.classList.contains('index')) {
    themeDom.qsa('.featured-products-section iframe[src*="youtube"], .featured-products-section iframe[src*="vimeo"]').forEach(function (ifr) {
      themeDom.jqMediaWrapper(ifr, { intrinsic: true });
    });
  } else {
    themeDom.qsa('iframe[src*="youtube"], iframe[src*="vimeo"]').forEach(function (ifr) {
      themeDom.jqMediaWrapper(ifr, { intrinsic: true });
    });
  }

  if (themeDom.windowWidth() >= 959) {
    var modal_width = '870px';
    if (themeDom.windowWidth() >= 1200 || document.documentElement.classList.contains('ie')) {
      modal_width = '1110px';
    }
  }

  if (Shopify.theme_settings.collection_swatches) {
    if (themeDom.windowWidth() > 798) {
      themeDom.delegate(document.body, 'mouseenter', '.collection_swatches', function () {
        themeDom.qsa('.swatch span', this).forEach(function (span) {
          var imgUrl = themeDom.dataAttr(span, 'image') || span.getAttribute('data-image');
          if (imgUrl && imgUrl.indexOf('no-image') === -1) {
            var pre = new Image();
            pre.src = imgUrl;
          }
        });
      });
      themeDom.delegate(document.body, 'mouseenter', '.swatch span', function () {
        var imgUrl = themeDom.dataAttr(this, 'image') || this.getAttribute('data-image');
        if (!imgUrl || imgUrl.indexOf('no-image') !== -1) return;
        var thumb = themeDom.closestParent(this, '.thumbnail');
        if (!thumb) return;
        themeDom.qsa('img:not(.secondary)', thumb).forEach(function (img) {
          img.setAttribute('src', imgUrl);
          img.setAttribute('srcset', imgUrl);
        });
      });
    }
  }

  if (Shopify.theme_settings.display_tos_checkbox) {
    function activateTosLabel(target) {
      var lbl = target && target.closest ? target.closest('.cart_content .tos_label') : null;
      if (!lbl) return;
      var inp = lbl.previousElementSibling;
      if (inp && inp.tagName === 'INPUT') inp.checked = true;
    }
    document.body.addEventListener('click', function (e) { activateTosLabel(e.target); });
    document.body.addEventListener('touchstart', function (e) { activateTosLabel(e.target); }, { passive: true });
  }

  if (Shopify.theme_settings.display_tos_checkbox && Shopify.theme_settings.go_to_checkout) {
    themeDom.delegate(document.body, 'click', '.cart_content .action_button', function (e) {
      var form = themeDom.closestParent(this, 'form');
      var agree = form ? form.querySelector('.tos_agree') : null;
      if (agree && agree.checked) {
        if (Shopify.theme_settings.go_to_checkout) {
          if (this.tagName === 'INPUT' || this.tagName === 'BUTTON') {
            if (form) form.submit();
          }
        } else {
          e.preventDefault();
          document.location.href = '/cart';
        }
      } else {
        var warning = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + '</p>';
        if (!themeDom.qs('p.warning')) {
          this.insertAdjacentHTML('beforebegin', warning);
        }
        e.preventDefault();
      }
    });
  } else if (!Shopify.theme_settings.go_to_checkout) {
    themeDom.delegate(document.body, 'click', '.cart_content .action_button', function (e) {
      e.preventDefault();
      document.location.href = '/cart';
    });
  }

  if (Shopify.theme_settings.collection_secondary_image) {
    imageFunctions.showSecondaryImage();
  }

  themeDom.qsa('.newsletter .contact-form').forEach(function (cf) {
    cf.addEventListener('submit', function (e) {
      var ch = cf.querySelector('input[name="challenge"]');
      if (ch && ch.value !== 'true') {
        themeDom.ajax({
          type: cf.getAttribute('method') || 'POST',
          url: cf.getAttribute('action') || '',
          data: themeDom.serializeForm(cf),
          success: function () {
            themeDom.fadeOut(cf, 'slow', function () {
              var prev = cf.previousElementSibling;
              if (prev && prev.classList.contains('message')) {
                prev.innerHTML = Shopify.translation.newsletter_success_text;
              }
            });
          },
          error: function () {
            if (ch) ch.value = 'true';
            cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  themeDom.qsa('.maps').forEach(function (mapEl) {
    mapEl.addEventListener('click', function () {
      themeDom.qsa('.maps iframe').forEach(function (ifr) {
        ifr.style.pointerEvents = 'auto';
      });
    });
  });

  if (Shopify.theme_settings.pagination_type === 'load_more') {
    enableLoadMoreProducts();
  }




  var globalQuickShopProduct;

  themeDom.delegate(document.body, 'change', '.js-quick-shop select', function () {
    var sel = themeDom.qs('.js-quick-shop select[name="id"]');
    var currentVariant = sel ? sel.value : '';
    if (currentVariant && globalQuickShopProduct) {
      quickShop.updateVariant(currentVariant);
    }
  });

  var quickShop = {
    init: function () {
      var productData;
      var productForm;
      var notifyForm;

      if (!quickShop._closedGalleryCleanupBound) {
        quickShop._closedGalleryCleanupBound = true;
        themeDom.delegate(document, 'closed', '.js-quick-shop', function () {
          var gallery = themeDom.qs('.js-gallery-modal');
          var carousel = themeDom.qs('.js-gallery-carousel');
          if (gallery) {
            themeDom.flickityRemove(gallery, '.gallery-cell');
            gallery.classList.remove('single-image', 'multi-image');
          }
          if (carousel) themeDom.empty(carousel);
        });
      }

      themeDom.delegate(document.body, 'click', '.js-quick-shop-link', function (e) {
        e.preventDefault();
        var link = this;

        var rawImages = themeDom.dataAttr(link, 'images') || link.getAttribute('data-images') || '';
        var arr = String(rawImages).replace(/^\|\|+|\|\|+$/g, '').split('||');
        var imageIds = [];
        var imageAlts = [];
        for (var im = 0; im < arr.length; im += 2) {
          imageIds.push(arr[im]);
          arr[im + 1] && imageAlts.push(arr[im + 1]);
        }

        var chRaw = themeDom.dataAttr(link, 'collectionHandles') || link.getAttribute('data-collection-handles') || '';
        productData = {
          handle: themeDom.dataAttr(link, 'handle'),
          product_id: themeDom.dataAttr(link, 'id'),
          single_variant: link.getAttribute('data-single-variant'),
          product_in_collection_url: themeDom.dataAttr(link, 'url'),
          escaped_title: themeDom.dataAttr(link, 'title'),
          details_text: themeDom.dataAttr(link, 'detailsText') || link.getAttribute('data-details-text'),
          full_description: themeDom.dataAttr(link, 'fullDescription') || link.getAttribute('data-full-description'),
          regular_description: themeDom.dataAttr(link, 'regularDescription') || link.getAttribute('data-regular-description'),
          image_ids: imageIds.filter(function (v) { return v !== '' }),
          image_alts: imageAlts,
          collection_handles: String(chRaw).split(',').map(function (s) { return s.trim(); }).filter(Boolean),
          money_format: themeDom.dataAttr(link, 'moneyFormat') || link.getAttribute('data-money-format')
        };

        var gModalInit = themeDom.qs('.js-gallery-modal');
        var qsAutoplay = gModalInit && (themeDom.dataAttr(gModalInit, 'autoplay') || gModalInit.getAttribute('data-autoplay'));

        if (gModalInit && !gModalInit.classList.contains('flickity-enabled')) {
          themeDom.flickityCreate(gModalInit, {
            wrapAround: true,
            cellAlign: 'left',
            contain: true,
            imagesLoaded: true,
            lazyLoad: 2,
            pageDots: usePageDots,
            prevNextButtons: true,
            autoPlay: qsAutoplay ? 6000 : false,
            selectedAttraction: 0.01,
            friction: 0.15,
            arrowShape: arrowSize
          });
        }

        var formsWrap = link.nextElementSibling;
        while (formsWrap && !formsWrap.classList.contains('js-forms')) {
          formsWrap = formsWrap.nextElementSibling;
        }
        notifyForm = formsWrap ? formsWrap.querySelector('.notify_form') : null;
        productForm = formsWrap ? formsWrap.querySelector('.product_form') : null;

        themeDom.qsa('.quick-shop .container').forEach(function (box) {
          box.className = 'container section product-' + productData.product_id;
          box.id = 'product-' + productData.product_id;
          box.setAttribute('data-id', String(productData.product_id));
        });

        quickShop.retrieveProductInfo(productData);

      });

      themeDom.delegate(document.body, 'opened', '.js-quick-shop', function () {

        var prodSlot = themeDom.qs('.remodal.quick-shop .js-product-form');
        var notifySlot = themeDom.qs('.remodal.quick-shop .js-notify-form');
        if (prodSlot && productForm) prodSlot.innerHTML = '';
        if (notifySlot && notifyForm) notifySlot.innerHTML = '';
        if (prodSlot && productForm) prodSlot.appendChild(productForm);
        if (notifySlot && notifyForm) notifySlot.appendChild(notifyForm);

        if (productForm && productForm.classList.contains('product_form_options') && !productForm.classList.contains('viewed')) {
          var sid = themeDom.dataAttr(productForm, 'selectId') || productForm.getAttribute('data-select-id');
          var prodJson = themeDom.dataAttr(productForm, 'product');
          var enState = themeDom.dataAttr(productForm, 'enableState');
          new Shopify.OptionSelectors(sid, { product: prodJson, onVariantSelected: selectCallback, enableHistoryState: enState });
        }

        if (Shopify.theme_settings.product_form_style === 'swatches') {
          var JSONData = themeDom.dataAttr(productForm, 'product');
          var swatchOptions = themeDom.qsa('.swatch_options .swatch', productForm);
          if (swatchOptions.length > 1) {
            Shopify.linkOptionSelectors(JSONData, '.js-quick-shop');
          }
        }

        utils.initializeTabs();
        var idSel = themeDom.qs('.js-quick-shop select[name="id"]');
        if (idSel) themeDom.trigger(idSel, 'change');

      });

      themeDom.delegate(document.body, 'closed', '.js-quick-shop', function () {

        var insertedProductForm = themeDom.qs('.js-quick-shop .product_form');
        var insertedNotifyForm = themeDom.qs('.js-quick-shop .notify_form');
        var holder = themeDom.qs('.form-holder-' + productData.product_id);

        if (holder && insertedProductForm) holder.appendChild(insertedProductForm);
        if (holder && insertedNotifyForm) holder.appendChild(insertedNotifyForm);
        if (holder) {
          themeDom.qsa('.product_form', holder).forEach(function (f) { f.classList.add('viewed'); });
          themeDom.qsa('.notify_form', holder).forEach(function (f) { f.classList.add('viewed'); });
        }
        var priceMoney = themeDom.qs('.js-current-price .money');
        var variantPrice = priceMoney ? priceMoney.textContent : '';
        themeDom.qsa('.js-quick-shop-link[data-id="' + productData.product_id + '"]').forEach(function (a) {
          a.setAttribute('data-initial-modal-price', variantPrice);
        });
        themeDom.qsa('.js-current-price, .js-was-price, .js-savings').forEach(function (el) { themeDom.empty(el); });
      });

    },
    retrieveProductInfo: function (productData) {

      var raw = themeDom.ajaxSyncJson('/products/' + productData.handle + '.js');
      if (!raw) return;
      var merged = themeDom.extend(themeDom.extend({}, raw), productData);
      quickShop.populateGallery(merged);

      globalQuickShopProduct = merged;

      quickShop.updateVariant(merged.variants[0].id.toString());

    },
    updateVariant: function (variant) {
      var qsPre = '.js-quick-shop ';
      themeDom.qsa(qsPre + '.js-sale-banner, ' + qsPre + '.js-sold-out, ' + qsPre + '.js-current-price, ' + qsPre + '.js-was-price, ' + qsPre + '.js-savings, ' + qsPre + '.js-new-banner, ' + qsPre + '.js-pre-order-banner').forEach(function (el) {
        themeDom.empty(el);
      });

      if (globalQuickShopProduct) {
        var product = globalQuickShopProduct;

        themeDom.qsa('.js-quick-shop .modal_price, .js-quick-shop .js-notify-form').forEach(function (el) { themeDom.show(el); });

        themeDom.qsa('.js-quick-shop .js-product-title').forEach(function (el) {
          el.innerHTML = '<a href="' + product.product_in_collection_url + '" title="' + product.escaped_title + '">' + product.title + '</a>';
        });
        themeDom.qsa('.js-quick-shop .js-product-vendor').forEach(function (el) {
          el.innerHTML = '<a href="/collections/vendors?q=' + product.vendor + '">' + product.vendor + '</a>';
        });

        themeDom.qsa('.js-quick-shop .js-full-description').forEach(function (el) { el.innerHTML = product.full_description; });
        themeDom.qsa('.js-quick-shop .js-regular-description').forEach(function (el) { el.innerHTML = product.regular_description; });
        var productDetails = '<a href="' + product.product_in_collection_url + '" class="secondary_button" title="' + product.escaped_title + ' Details">' + product.details_text + '</a>';
        themeDom.qsa('.js-quick-shop .js-product-details').forEach(function (el) { el.innerHTML = productDetails; });

        (product.collection_handles || []).forEach(function (h) {
          var tag = String(h);
          if (tag === 'new') {
            themeDom.qsa('.js-quick-shop .js-new-banner').forEach(function (el) {
              el.innerHTML = Shopify.translation.new_text;
            });
          }
          if (tag === 'pre-order') {
            themeDom.qsa('.js-quick-shop .js-pre-order-banner').forEach(function (el) {
              el.innerHTML = Shopify.translation.pre_order_text;
            });
          }
          if (tag === 'coming-soon') {
            product.price = Shopify.translation.coming_soon_text;
          }
        });

        if (product.single_variant == 'true') {

          if (Shopify.theme_settings.sale_banner_enabled) {
            if (product.compare_at_price > product.price) {
              themeDom.qsa('.js-quick-shop .js-sale-banner').forEach(function (el) {
                el.innerHTML = Shopify.translation.sale_text;
              });
            }
          }

          if (product.compare_at_price > product.price) {
            themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) { el.classList.add('sale'); });
          } else {
            themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) { el.classList.remove('sale'); });
          }

          if (product.available == false) {
            themeDom.qsa('.js-quick-shop .js-sold-out').forEach(function (el) {
              el.innerHTML = Shopify.translation.sold_out_text;
            });
          }

          if (product.available == true) {

            if (product.compare_at_price > product.price) {
              themeDom.qsa('.js-quick-shop .js-was-price').forEach(function (el) {
                el.innerHTML = '<span class="money">' + Shopify.formatMoney(product.compare_at_price, product.money_format) + '</span>';
              });
              themeDom.qsa('.js-quick-shop .js-savings').forEach(function (el) {
                el.innerHTML = Shopify.translation.savings_text + ' ' + parseInt(((product.compare_at_price - product.price) * 100) / product.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(product.compare_at_price - product.price, product.money_format) + '</span>)';
              });
            }

            if (product.price == Shopify.translation.coming_soon_text) {
              themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) {
                el.innerHTML = Shopify.translation.coming_soon_text;
              });
            } else if (product.price) {
              themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) {
                el.innerHTML = '<span class="money">' + Shopify.formatMoney(product.price, product.money_format) + '</span>';
              });
            } else {
              themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) {
                el.innerHTML = Shopify.theme_settings.free_text;
              });
            }
          }
        } else {
          for (var i = 0; i < product.variants.length; i++) {
            if (variant == product.variants[i].id.toString()) {
              if (Shopify.theme_settings.sale_banner_enabled) {
                if (product.variants[i].compare_at_price > product.variants[i].price) {
                  themeDom.qsa('.js-quick-shop .js-sale-banner').forEach(function (el) {
                    el.innerHTML = Shopify.translation.sale_text;
                  });
                }
              }

              if (product.variants[i].compare_at_price > product.variants[i].price) {
                themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) { el.classList.add('sale'); });
              } else {
                themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) { el.classList.remove('sale'); });
              }

              if (product.variants[i].available == false) {
                themeDom.qsa('.js-quick-shop .js-sold-out').forEach(function (el) {
                  el.innerHTML = Shopify.translation.sold_out_text;
                });
              }

              if (product.variants[i].available == true) {

                if (product.variants[i].compare_at_price > product.variants[i].price) {
                  themeDom.qsa('.js-quick-shop .js-was-price').forEach(function (el) {
                    el.innerHTML = '<span class="money">' + Shopify.formatMoney(product.variants[i].compare_at_price, product.money_format) + '</span>';
                  });
                  themeDom.qsa('.js-quick-shop .js-savings').forEach(function (el) {
                    el.innerHTML = Shopify.translation.savings_text + ' ' + parseInt(((product.variants[i].compare_at_price - product.variants[i].price) * 100) / product.variants[i].compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(product.variants[i].compare_at_price - product.variants[i].price, product.money_format) + '</span>)';
                  });
                }

                if (product.variants[i].price == Shopify.translation.coming_soon_text) {
                  themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) {
                    el.innerHTML = Shopify.translation.coming_soon_text;
                  });
                } else if (product.variants[i].price) {
                  themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) {
                    el.innerHTML = '<span class="money">' + Shopify.formatMoney(product.variants[i].price, product.money_format) + '</span>';
                  });
                } else {
                  themeDom.qsa('.js-quick-shop .js-current-price').forEach(function (el) {
                    el.innerHTML = Shopify.theme_settings.free_text;
                  });
                }
              }
            }
          }
        }
      }

      themeDom.qsa('.js-quick-shop iframe[src*="youtube"], .js-quick-shop iframe[src*="vimeo"]').forEach(function (ifr) {
        themeDom.jqMediaWrapper(ifr, { intrinsic: true });
      });

    },
    populateGallery: function (product) {

      var gallery = themeDom.qs('.js-gallery-modal');
      var carousel = themeDom.qs('.js-gallery-carousel');

      function addMainGalleryImages(multiImage) {

        product.images.forEach(function (imgPath, i) {

          var imgGrande = imgPath.replace(/(\.[^.]*)$/, "_grande$1").replace('http:', '');
          var img1024x1024 = imgPath.replace(/(\.[^.]*)$/, "_1024x1024$1").replace('http:', '');
          var img2048x2048 = imgPath.replace(/(\.[^.]*)$/, "_2048x2048$1").replace('http:', '');
          var alt = product.image_alts[i] || '';
          var cellContent;

          if (alt.indexOf('youtube') >= 0) {
            cellContent = '<div class="video-container youtube"><div>' + alt + '</div></div>';
          } else if (alt.indexOf('vimeo') >= 0) {
            cellContent = '<div class="video-container vimeo"><div>' + alt + '</div></div>';
          } else {
            var iid = product.image_ids[i] ? String(product.image_ids[i]).trim() : '';
            cellContent = '<img src="' + imgGrande + '" data-src="' + img1024x1024 + '" alt="' + alt + '" data-image-id="' + iid + '" data-index="' + i + '" srcset="' + imgGrande + ' 600w, ' + img1024x1024 + ' 1024w, ' + img2048x2048 + ' 2048w" sizes="(min-width: 800px) 50vw, 100vw"/>';
          }

          var cell = document.createElement('div');
          cell.className = 'gallery-cell';
          cell.innerHTML = cellContent;
          var flkty = themeDom.flickityData(gallery);
          if (flkty) flkty.append(cell);
        });

        if (gallery) {
          gallery.classList.remove('single-image', 'multi-image');
          gallery.classList.add(multiImage ? 'multi-image' : 'single-image');
        }

      }

      function addCarouselGalleryImages() {
        product.images.forEach(function (imgPath, i) {
          var carouselSizedImg = imgPath.replace(/(\.[^.]*)$/, "_grande$1").replace('http:', '');

          var img = '<img src="' + carouselSizedImg + '" alt="' + (product.image_alts[i] || '') + '" />';
          var cell = document.createElement('div');
          cell.className = 'gallery-cell';
          cell.innerHTML = img;
          if (carousel) carousel.appendChild(cell);
        });

        if (gallery && carousel) imageFunctions.linkGalleryAndCarousel(gallery, carousel);

      }

      var multiImage;

      if (product.images.length > 1) {
        multiImage = true;
        addMainGalleryImages(multiImage);
        addCarouselGalleryImages();
      } else {
        multiImage = false;
        addMainGalleryImages(multiImage);
      }

      imageFunctions.zoom('.js-gallery-modal', false);

    }
  }

  if (Shopify.theme_settings.quick_shop_enabled) {
    quickShop.init();
  }



  function ajaxSubmitCart(cartForm) {
    themeDom.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: themeDom.serializeForm(themeDom.el(cartForm)),
      success: function (data) {
        Shopify.getCart(function (cart) {
          refreshCart(cart);
        }, data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    var parentEl = themeDom.el(parent);
    themeDom.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        Shopify.getCart(function (cartData) {
          refreshCart(cartData);
        });

        var lineIDIndex = lineID - 1;

        if (typeof data.items[lineIDIndex] === "undefined") {
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if (quantity > 0 && quantity != updated_quantity) {
          var items_left_text;
          if (updated_quantity == 1) {
            items_left_text = Shopify.translation.one_item_left;
          } else {
            items_left_text = Shopify.translation.items_left_text;
          }

          themeDom.qsa('.warning--quantity').forEach(function (w) { w.remove(); });

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          if (parentEl) {
            var lineInp = parentEl.querySelector("input[data-line-id='" + lineID + "']");
            if (lineInp && lineInp.parentElement) {
              lineInp.parentElement.insertAdjacentHTML('afterend', warning);
              lineInp.value = String(updated_quantity);
            }
          }
        } else if (parentEl && parentEl.id === 'cart_form') {
          var cf = themeDom.qs('#cart_form');
          if (cf) cf.submit();
        }
      }
    });
  }

  function refreshCart(cart) {
    themeDom.qsa(".cart_count").forEach(function (cbtn) {
      var value = cbtn.textContent || '0';
      cbtn.textContent = value.replace(/[0-9]+/, String(cart.item_count));
    });

    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var cartForm = themeDom.qs(".cart_content form");
    var moneyFormat = cartForm ? (themeDom.dataAttr(cartForm, 'moneyFormat') || cartForm.getAttribute('data-money-format') || '') : '';
    var discounted_price_total = 0;
    var total_savings = 0;

    if (cart.item_count == 0) {
      themeDom.qsa('.js-empty-cart__message').forEach(function (el) { el.classList.remove('hidden'); });
      themeDom.qsa('.js-cart_content__form').forEach(function (el) { el.classList.add('hidden'); });
    } else {
      themeDom.qsa('.js-empty-cart__message').forEach(function (el) { el.classList.add('hidden'); });
      themeDom.qsa('.js-cart_content__form').forEach(function (el) { el.classList.remove('hidden'); });

      cart.items.forEach(function (item, index) {
        var line_id = index + 1;
        cart_items_html += '<li class="cart_item clearfix">' +
          '<a href="' + item.url + '">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
            '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }

        cart_items_html += '<strong class="right price">';

        if (Shopify.theme_settings.display_savings) {
          var pdata = themeDom.ajaxSyncJson("/products/" + item.handle + ".js");
          if (pdata && pdata.variants) {
            var variant_id = item.variant_id;
            var variant = pdata.variants.filter(function (v) {
              return v.id == variant_id;
            })[0];

            if (variant && variant.compare_at_price > item.price) {
              cart_items_html += ' <span class="money was_price">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</span> ';
              discounted_price_total += item.price * item.quantity;
              total_savings += variant.compare_at_price * item.quantity;
            }
          }
        }

        cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, moneyFormat) + '</span></strong>' +
          '<div class="item_title">' + item.title;

        if (item.properties) {
          Object.keys(item.properties).forEach(function (title) {
            var value = item.properties[title];
            if (value) {
              cart_items_html += '<div class="line-item">' + title + ': ' + value + '</div>';
            }
          });
        }

        cart_items_html += '</div></a>';

        cart_items_html += '<div class="left product-quantity-box">' +
          '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
          '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-line-id="' + line_id + '" />' +
          '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
          '</div>' +
          '</li>';
      });

      cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, moneyFormat) + '</span></span>' +
        '<span>' + Shopify.translation.cart_subtotal_text + '</span>';

      if (total_savings > 0) {
        cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, moneyFormat) + '</span></span>' +
          '<span>' + Shopify.translation.cart_savings_text + '</span>';
      } else {
        cart_savings_html = "";
      }
    }

    themeDom.qsa('.js-cart_items').forEach(function (el) { el.innerHTML = cart_items_html; });
    themeDom.qsa('.js-cart_subtotal').forEach(function (el) { el.innerHTML = cart_action_html; });
    themeDom.qsa('.js-cart_savings').forEach(function (el) { el.innerHTML = cart_savings_html; });
  }

  themeDom.delegate(document.body, 'change', '#cart_form input.quantity', function () {
    var lid = themeDom.dataAttr(this, 'lineId') || this.getAttribute('data-line-id');
    ajaxUpdateCart(parseInt(lid, 10), this.value, themeDom.closestParent(this, '#cart_form'));
  });

  themeDom.delegate(document.body, 'change', '.cart_content input.quantity', function () {
    var lid = themeDom.dataAttr(this, 'lineId') || this.getAttribute('data-line-id');
    ajaxUpdateCart(parseInt(lid, 10), this.value, themeDom.closestParent(this, '.cart_content'));
  });

  if (Shopify.theme_settings.cart_action === 'ajax') {
    themeDom.delegate(document.body, 'submit', '.product_form', function (e) {
      e.preventDefault();
      var addToCartForm = this;
      var addToCartBtn = addToCartForm.querySelector('.add_to_cart');

      themeDom.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: themeDom.serializeForm(addToCartForm),
        beforeSend: function () {
          if (addToCartBtn) {
            addToCartBtn.setAttribute('disabled', 'disabled');
            addToCartBtn.classList.add('disabled');
            themeDom.qsa('span', addToCartBtn).forEach(function (s) {
              s.classList.remove('fadeInDown');
              s.classList.add('animated', 'zoomOut');
            });
          }
        },
        success: function () {
          if (addToCartBtn) {
            var cm = addToCartBtn.querySelector('.checkmark');
            if (cm) cm.classList.add('checkmark-active');
          }

          window.setTimeout(function () {
            if (addToCartBtn) {
              addToCartBtn.removeAttribute('disabled');
              addToCartBtn.classList.remove('disabled');
              var cm2 = addToCartBtn.querySelector('.checkmark');
              if (cm2) cm2.classList.remove('checkmark-active');
              themeDom.qsa('span', addToCartBtn).forEach(function (s) {
                s.classList.remove('zoomOut');
                s.classList.add('fadeInDown');
              });
            }
          }, 1000);

          Shopify.getCart(function (cart) {
            refreshCart(cart);
            if (document.documentElement.classList.contains('remodal-is-locked')) {
              themeDom.jqTriggerClick('.remodal-close');
            }

            var hdr = themeDom.qs('#header');
            if (hdr && themeDom.isVisible(hdr)) {
              themeDom.qsa('#header .cart_container').forEach(function (el) { el.classList.add('active_link'); });
              window.setTimeout(function () {
                themeDom.qsa('#header .cart_container').forEach(function (el) { el.classList.remove('active_link'); });
              }, 5000);
            } else if (themeDom.qs('.sticky_nav--stick')) {
              themeDom.qsa('.sticky_nav .cart_container').forEach(function (el) { el.classList.add('active_link'); });
              window.setTimeout(function () {
                themeDom.qsa('.sticky_nav .cart_container').forEach(function (el) { el.classList.remove('active_link'); });
              }, 5000);

            } else {
              themeDom.qsa('.top_bar .cart_container').forEach(function (el) { el.classList.add('active_link'); });
              window.setTimeout(function () {
                themeDom.qsa('.top_bar .cart_container').forEach(function (el) { el.classList.remove('active_link'); });
              }, 5000);
            }
          });
        },


        error: function (xhr) {
          var response = parseShopifyCartAddError(xhr);
          themeDom.qsa('.warning').forEach(function (w) { w.remove(); });

          var warning = '<p class="warning animated bounceIn">' + String(response).replace('All 1 ', 'All ') + '</p>';
          addToCartForm.insertAdjacentHTML('afterend', warning);
          if (addToCartBtn) {
            addToCartBtn.removeAttribute('disabled');
            addToCartBtn.classList.remove('disabled');
            themeDom.qsa('span', addToCartBtn).forEach(function (s) {
              s.textContent = Shopify.translation.add_to_cart;
              s.classList.remove('zoomOut');
              s.classList.add('zoomIn');
            });
          }
        }
      });

      return false;
    });
  } else if (Shopify.theme_settings.cart_action === 'notification' || Shopify.theme_settings.cart_action === 'app_configured') {
    themeDom.delegate(document.body, 'submit', '.product_form', function (e) {
      e.preventDefault();
      var addToCartForm = this;
      var addToCartBtn = addToCartForm.querySelector('.add_to_cart');

      themeDom.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: themeDom.serializeForm(addToCartForm),
        beforeSend: function () {
          if (addToCartBtn) {
            addToCartBtn.setAttribute('disabled', 'disabled');
            addToCartBtn.classList.add('disabled');
            themeDom.qsa('span', addToCartBtn).forEach(function (s) {
              s.classList.remove('fadeInDown');
              s.classList.add('animated', 'zoomOut');
            });
          }
        },
        success: function () {
          if (addToCartBtn) {
            var cm = addToCartBtn.querySelector('.checkmark');
            if (cm) cm.classList.add('checkmark-active');
          }
          var notification = themeDom.qs('.notification-area');
          if (notification) {
            notification.style.display = 'block';
            window.setTimeout(function () {
              notification.classList.add('show');
              themeDom.scrollAnimateY(0, 500);
            }, 100);
          }

          window.setTimeout(function () {
            if (addToCartBtn) {
              addToCartBtn.removeAttribute('disabled');
              addToCartBtn.classList.remove('disabled');
              var cm2 = addToCartBtn.querySelector('.checkmark');
              if (cm2) cm2.classList.remove('checkmark-active');
              themeDom.qsa('span', addToCartBtn).forEach(function (s) {
                s.classList.remove('zoomOut');
                s.classList.add('fadeInDown');
              });
            }
          }, 1000);

          Shopify.getCart(function (cart) {
            themeDom.qsa(".cart_count").forEach(function (cbtn) {
              var value = cbtn.textContent || '0';
              cbtn.textContent = value.replace(/[0-9]+/, String(cart.item_count));
            });
          });
        },


        error: function (xhr) {
          var response = parseShopifyCartAddError(xhr);
          themeDom.qsa('.warning').forEach(function (w) { w.remove(); });

          var warning = '<p class="warning animated bounceIn">' + String(response).replace('All 1 ', 'All ') + '</p>';
          addToCartForm.insertAdjacentHTML('afterend', warning);
          if (addToCartBtn) {
            addToCartBtn.removeAttribute('disabled');
            addToCartBtn.classList.remove('disabled');
            themeDom.qsa('span', addToCartBtn).forEach(function (s) {
              s.textContent = Shopify.translation.add_to_cart;
              s.classList.remove('zoomOut');
              s.classList.add('zoomIn');
            });
          }
        }
      });

      return false;
    });

    themeDom.qsa('[data-item-added-action]').forEach(function (el) {
      el.addEventListener('click', function () {
        themeDom.qsa('.notification-area').forEach(function (na) {
          na.classList.remove('show');
          na.style.display = 'none';
        });
      });
    });
  }

  if (Shopify.theme_settings.product_form_style === 'swatches') {
    if (themeDom.qs('.js-product_section')) {
      themeDom.qsa('.js-product_section .product_form').forEach(function (form) {
        form.classList.add('is-visible');
        var JSONData = themeDom.dataAttr(form, 'product');
        var productID = themeDom.dataAttr(form, 'productId') || form.getAttribute('data-product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = themeDom.qsa('.swatch_options .swatch', form);
        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    }

    if (themeDom.qsa('.js-product_section').length > 1) {
      themeDom.delegate(document.body, 'click', '.swatch-element', function () {
        var swatchValue = themeDom.dataAttr(this, 'value');
        var sv = swatchValue != null ? String(swatchValue) : '';
        var par = this.parentElement;
        if (par) {
          for (var ci = 0; ci < par.children.length; ci++) {
            var ch = par.children[ci];
            if (ch.tagName === 'INPUT' && ch.value === sv) {
              ch.checked = true;
              themeDom.trigger(ch, 'change');
              break;
            }
          }
        }

        var pf = themeDom.closestParent(this, '.product_form');
        if (!pf) return;
        var JSONData = themeDom.dataAttr(pf, 'product');
        var productID = themeDom.dataAttr(pf, 'productId') || pf.getAttribute('data-product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = themeDom.qsa('.swatch_options .swatch', pf);
        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    }
  }

}






Shopify.updateOptionsInSelector = function (selectorIndex, parent) {

  var allSelects = themeDom.qsa(parent + ' .single-option-selector');
  var key;
  var selectorEl;

  switch (selectorIndex) {
    case 0:
      key = 'root';
      selectorEl = allSelects[0];
      break;
    case 1:
      key = allSelects[0] ? allSelects[0].value : '';
      selectorEl = allSelects[1];
      break;
    case 2:
      key = (allSelects[0] ? allSelects[0].value : '') + ' / ' + (allSelects[1] ? allSelects[1].value : '');
      selectorEl = allSelects[2];
      break;
  }

  var availableOptions = Shopify.optionsMap[key];

  themeDom.qsa(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').forEach(function (cell) {
    var dv = cell.getAttribute('data-value');
    var radios = cell.querySelectorAll('input[type="radio"]');
    var ok = availableOptions && availableOptions.indexOf(dv) !== -1;
    if (ok) {
      cell.classList.remove('soldout');
      radios.forEach(function (r) {
        r.removeAttribute('disabled');
        r.checked = false;
      });
    }
    else {
      cell.classList.add('soldout');
      radios.forEach(function (r) {
        r.checked = false;
        r.setAttribute('disabled', 'disabled');
      });
    }
  });
  if (selectorEl) themeDom.trigger(selectorEl, 'change');

};

Shopify.linkOptionSelectors = function (product, parent) {

  Shopify.optionsMap = {};
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {

      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);

      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }

      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }

  Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);

  var selA = themeDom.qsa(parent + ' .single-option-selector');
  if (selA[0]) {
    selA[0].addEventListener('change', function () {
      Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
  }
  if (selA[1]) {
    selA[1].addEventListener('change', function () {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
  }
};


function htmlEncode(value) {
  return themeDom.htmlEncodeText(value || '');
}


function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', themeBootstrap);
} else {
  themeBootstrap();
}





var social = {
  twitter: function () {
    if (!window.twttr) {

      window.twttr = (function (d, s, id) {
        var t, js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return; js = d.createElement(s); js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return window.twttr || (t = { _e: [], ready: function (f) { t._e.push(f) } });
      }(document, "script", "twitter-wjs"));
    }

    if (window.twttr) {
      window.twttr.ready(function (twttr) {
        twttr.widgets.load(
          document.getElementById("twitter-timeline")
        );
      });
    }
  },
  unload: function () {

  }
}

var instagram = {
  loadContent: function (s) {
    if (!s || !s.clientID) return;
    var container = themeDom.el(s.el);
    var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + s.clientID;

    themeDom.ajax({
      type: 'GET',
      url: url,
      dataType: 'jsonp',
      success: function (res) {

        if (res.meta.code === 200 && res.data.length) {
          var mediaList = res.data;
          var count = 0;
          if (container) themeDom.empty(container);

          for (var i = 0; i < mediaList.length; i++) {
            var thisMedia = mediaList[i];
            var item = '';

            var imgUrl = thisMedia.images.low_resolution.url;

            if (!(thisMedia.images.low_resolution.url.indexOf('null') > -1)) {
              item = '<div class="il-photo__img instagram__bg" style="background-image:url(' + imgUrl + ')" data-filter="' + thisMedia.filter + '" /></div>';
              item = '<a href="' + thisMedia.link + '" target="_blank" class="instagram__link">' + item + '</a>';
            }

            if (thisMedia.videos) {
              item = '<div class="instagram__video instagram__bg" style="background-image:url(' + imgUrl + ')" data-filter="' + thisMedia.filter + '" /></div>';
              item = '<a href="' + thisMedia.link + '" target="_blank" class="instagram__link instagram__video-link">' + item + '</a>';
            }

            if (item) {
              item = '<div class="four columns instagram__item">' + item + '</div>';
            }
            if (item !== '' && item !== undefined && container) {
              container.insertAdjacentHTML('beforeend', item);
              count++;
            }
            if (count == s.limit) {
              break;
            }
          }
        }
      },
      error: function () {
      }
    });
  }
}

themeDom.qsa('.social-feeds-wrap').forEach(function (wrap) {

  social.twitter();

  var target = wrap.querySelector('.js-instafeed');
  instagram.loadContent({
    el: target,
    clientID: target ? (themeDom.dataAttr(target, 'clientId') || target.getAttribute('data-client-id')) : '',
    limit: target ? (themeDom.dataAttr(target, 'count') || parseInt(target.getAttribute('data-count'), 10)) : 0
  });
});
document.addEventListener('shopify:block:select', function (e) {

  var blockId = e.detail.blockId;
  var parentSection = themeDom.qs('#shopify-section-' + e.detail.sectionId);

  if (parentSection && (parentSection.classList.contains('slideshow-section') || parentSection.classList.contains('testimonial-section'))) {
    sliderBlock.select(blockId, parentSection);
  }

  utils.resizeActionButtons();

});

document.addEventListener('shopify:block:deselect', function (e) {

  var parentSection = themeDom.qs('#shopify-section-' + e.detail.sectionId);

  if (parentSection && (parentSection.classList.contains('slideshow-section') || parentSection.classList.contains('testimonial-section'))) {
    sliderBlock.deselect(parentSection);
  }

});

document.addEventListener('shopify:section:reorder', function () {

  utils.pageBannerCheck();

});

document.addEventListener('shopify:section:load', function (e) {
  syncImageLoadingStyleClasses(e.target);

  var parentSection = themeDom.qs('#shopify-section-' + e.detail.sectionId);

  utils.pageBannerCheck();

  if (Shopify.theme_settings.newsletter_popup_feature) {
    newsletter_popup.init();
  }

  productpagenote_popup.init();

  if (parentSection && parentSection.classList.contains('social-feeds-section')) {
    themeDom.qsa('.social-feeds-wrap').forEach(function (wrap) {

      social.twitter();

      var target = wrap.querySelector('.js-instafeed');
      instagram.loadContent({
        el: target,
        clientID: target ? (themeDom.dataAttr(target, 'clientId') || target.getAttribute('data-client-id')) : '',
        limit: target ? (themeDom.dataAttr(target, 'count') || parseInt(target.getAttribute('data-count'), 10)) : 0
      });
    });
  }

  if (parentSection && parentSection.classList.contains('faq-section')) {
    faqAccordion.init();
  }

  if (parentSection && parentSection.classList.contains('cart-section')) {
    cart.init();
  }

  if (parentSection && parentSection.classList.contains('featured-promotions-section')) {
    featuredPromotions.init();
  }

  if (parentSection && parentSection.classList.contains('slideshow-section')) {
    slideshow.init();
  }

  if (parentSection && parentSection.classList.contains('testimonial-section')) {
    testimonial.init();
  }

  if (parentSection && parentSection.classList.contains('image-gallery-section')) {
    gallery.init();
  }

  if (parentSection && parentSection.classList.contains('featured-products-section')) {
    productPage.initializeQuantityBox();
    productPage.init();
  }

  if (parentSection && parentSection.classList.contains('featured-collection-section')) {
    featuredCollectionSection.init();
  }

  if (parentSection && parentSection.classList.contains('video-section')) {
    videoSection.init();
  }

  if (parentSection && parentSection.classList.contains('recently-viewed')) {
    recentlyViewed.init('.js-recently-viewed');
  }

  if (parentSection && parentSection.classList.contains('product-template')) {
    productPage.init();
    productPage.relatedProducts();
    recentlyViewed.init();

  }

  if (parentSection && parentSection.classList.contains('article-template-section')) {
    if (window.location.pathname.indexOf('/comments') !== -1) {
      var nc = themeDom.qs('#new-comment');
      if (nc) themeDom.scrollAnimateY(nc.getBoundingClientRect().top + themeDom.scrollTop() - 140, 600);
    }
  }

  if (parentSection && parentSection.classList.contains('collection-template-section')) {
    collectionSidebarFilter.init();
    collectionSidebarFilterMobile.init();
  }

  if (parentSection && parentSection.classList.contains('search-template-section')) {
    collection.init();
  }

  if (parentSection && parentSection.classList.contains('header-section')) {
    header.init();
  }

  if (parentSection && parentSection.classList.contains('page-details-section')) {
    featuredCollectionSection.init();
    videoSection.init();
  }
});


document.addEventListener('shopify:section:unload', function (e) {

  var target = e.target;
  var parentSection = themeDom.qs('#shopify-section-' + e.detail.sectionId);

  if (parentSection && parentSection.classList.contains('header-section')) {
    header.unload(target);
  }

  if (parentSection && parentSection.classList.contains('slideshow-section')) {
    slideshow.unload(target);
  }

  if (parentSection && parentSection.classList.contains('testimonial-section')) {
    testimonial.unload(target);
  }

  if (parentSection && parentSection.classList.contains('video-section')) {
    videoSection.unload(target);
  }

  if (parentSection && parentSection.classList.contains('product-template')) {
    productPage.unload(target);
  }

  if (parentSection && parentSection.classList.contains('page-details-section')) {
    videoSection.unload(target);
  }

});

document.addEventListener('shopify:section:select', function (e) {

  var parentSection = themeDom.qs('#shopify-section-' + e.detail.sectionId);

  if (parentSection && parentSection.classList.contains('social-feeds-section')) {
    themeDom.qsa('.social-feeds-wrap').forEach(function () {
      social.twitter();
    });
  }

  if (parentSection && parentSection.classList.contains('featured-collection-section')) {
    featuredCollectionSection.unload(parentSection);
    featuredCollectionSection.init();
  }

  utils.pageBannerCheck();
  window.dispatchEvent(new Event('resize', { bubbles: true }));
});

function initProductOptionPlaceholders() {
  if (typeof productOptions === 'undefined') return;
  for (var i = 0; i < productOptions.length; i++) {
    var sel = themeDom.qsa('.single-option-selector')[i];
    if (!sel || sel.querySelectorAll('option').length <= 1) continue;
    var opt = document.createElement('option');
    opt.value = '';
    opt.textContent = 'Pick a ' + productOptions[i][i];
    sel.insertBefore(opt, sel.firstChild);
    sel.value = '';
    themeDom.trigger(sel, 'change');
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductOptionPlaceholders);
} else {
  initProductOptionPlaceholders();
}
if (Shopify.theme_settings.enable_back_to_top_btn) {
  var BacktoTop = themeDom.qs('#back-to-top-btn');
  var backToTopScrollScheduled = false;

  window.addEventListener('scroll', function () {
    if (backToTopScrollScheduled) {
      return;
    }
    backToTopScrollScheduled = true;
    window.requestAnimationFrame(function () {
      backToTopScrollScheduled = false;
      if (!BacktoTop) return;
      if (themeDom.scrollTop() > 500) {
        BacktoTop.classList.add('show');
      } else {
        BacktoTop.classList.remove('show');
      }
    });
  }, { passive: true });

  if (BacktoTop) BacktoTop.addEventListener('click', function (e) {
    e.preventDefault();
    themeDom.scrollAnimateY(0, 500);
  });
}

(function setupGtmFormTracking() {
  var btn = document.getElementById('nf-submit-button-10913');
  if (!btn) return;
  btn.addEventListener('click', function () {
    if (typeof gtag === 'function') gtag('event', 'Submit', { event_category: 'Form', event_Label: 'Submit' });
  });
})();